import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
import * as dcei_engine_effect_proto from './dcei_engine_effect_proto';
class Ability_AbilityType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE_ABILITY_TYPE": return 0;
        case "TARGET": return 1;
        case "INSTANT": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Ability_AbilityType.fromJson(value);
  }
  static fromReact(e) {
    return Ability_AbilityType.fromJson(e);
  }
}
Ability_AbilityType.NONE_ABILITY_TYPE = 0;
Ability_AbilityType.TARGET = 1;
Ability_AbilityType.INSTANT = 2;
Ability_AbilityType.default = 0;
Ability_AbilityType.values = {
  NONE_ABILITY_TYPE: 0,
  TARGET: 1,
  INSTANT: 2,
};
Ability_AbilityType.names = {
  0: "NONE_ABILITY_TYPE",
  1: "TARGET",
  2: "INSTANT",
};
class Ability_CastType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NONE_CAST_TYPE": return 0;
        case "MANUAL": return 1;
        case "AUTO": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Ability_CastType.fromJson(value);
  }
  static fromReact(e) {
    return Ability_CastType.fromJson(e);
  }
}
Ability_CastType.NONE_CAST_TYPE = 0;
Ability_CastType.MANUAL = 1;
Ability_CastType.AUTO = 2;
Ability_CastType.default = 0;
Ability_CastType.values = {
  NONE_CAST_TYPE: 0,
  MANUAL: 1,
  AUTO: 2,
};
Ability_CastType.names = {
  0: "NONE_CAST_TYPE",
  1: "MANUAL",
  2: "AUTO",
};
class Ability_TargetRangeModes {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "NORMAL": return 0;
        case "CLAMP": return 1;
        case "MAX_RANGE": return 2;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Ability_TargetRangeModes.fromJson(value);
  }
  static fromReact(e) {
    return Ability_TargetRangeModes.fromJson(e);
  }
}
Ability_TargetRangeModes.NORMAL = 0;
Ability_TargetRangeModes.CLAMP = 1;
Ability_TargetRangeModes.MAX_RANGE = 2;
Ability_TargetRangeModes.default = 0;
Ability_TargetRangeModes.values = {
  NORMAL: 0,
  CLAMP: 1,
  MAX_RANGE: 2,
};
Ability_TargetRangeModes.names = {
  0: "NORMAL",
  1: "CLAMP",
  2: "MAX_RANGE",
};
class Ability_UiButtonPositionType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "UI_BUTTON_POSITION_TYPE_UNKNOWN": return 0;
        case "LEFT": return 1;
        case "RIGHT": return 2;
        case "UP": return 3;
        case "DOWN": return 4;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Ability_UiButtonPositionType.fromJson(value);
  }
  static fromReact(e) {
    return Ability_UiButtonPositionType.fromJson(e);
  }
}
Ability_UiButtonPositionType.UI_BUTTON_POSITION_TYPE_UNKNOWN = 0;
Ability_UiButtonPositionType.LEFT = 1;
Ability_UiButtonPositionType.RIGHT = 2;
Ability_UiButtonPositionType.UP = 3;
Ability_UiButtonPositionType.DOWN = 4;
Ability_UiButtonPositionType.default = 0;
Ability_UiButtonPositionType.values = {
  UI_BUTTON_POSITION_TYPE_UNKNOWN: 0,
  LEFT: 1,
  RIGHT: 2,
  UP: 3,
  DOWN: 4,
};
Ability_UiButtonPositionType.names = {
  0: "UI_BUTTON_POSITION_TYPE_UNKNOWN",
  1: "LEFT",
  2: "RIGHT",
  3: "UP",
  4: "DOWN",
};
class Ability_UiButtonImageType {
  static fromJson(json) {
    if (typeof json === "string") {
      switch (json) {
        case "UI_BUTTON_IMAGE_TYPE_UNKNOWN": return 0;
        case "BARRACKS": return 1;
        case "CANNON": return 2;
        case "CANNON_V2": return 3;
        case "CANNON_V3": return 4;
        case "REPEATER_V1": return 5;
        case "TESLA_V1": return 6;
        case "TESLA_V2": return 7;
        case "D_ARROW": return 8;
        case "D_BARRACKS": return 9;
        case "D_CANNON": return 10;
        case "D_TESLA": return 11;
        case "D_COIN": return 12;
        default: return 0;
      }
    }
    return json;
  }
  static toJson(value) {
    return value;
  }
  static fromAny(value) {
    return Ability_UiButtonImageType.fromJson(value);
  }
  static fromReact(e) {
    return Ability_UiButtonImageType.fromJson(e);
  }
}
Ability_UiButtonImageType.UI_BUTTON_IMAGE_TYPE_UNKNOWN = 0;
Ability_UiButtonImageType.BARRACKS = 1;
Ability_UiButtonImageType.CANNON = 2;
Ability_UiButtonImageType.CANNON_V2 = 3;
Ability_UiButtonImageType.CANNON_V3 = 4;
Ability_UiButtonImageType.REPEATER_V1 = 5;
Ability_UiButtonImageType.TESLA_V1 = 6;
Ability_UiButtonImageType.TESLA_V2 = 7;
Ability_UiButtonImageType.D_ARROW = 8;
Ability_UiButtonImageType.D_BARRACKS = 9;
Ability_UiButtonImageType.D_CANNON = 10;
Ability_UiButtonImageType.D_TESLA = 11;
Ability_UiButtonImageType.D_COIN = 12;
Ability_UiButtonImageType.default = 0;
Ability_UiButtonImageType.values = {
  UI_BUTTON_IMAGE_TYPE_UNKNOWN: 0,
  BARRACKS: 1,
  CANNON: 2,
  CANNON_V2: 3,
  CANNON_V3: 4,
  REPEATER_V1: 5,
  TESLA_V1: 6,
  TESLA_V2: 7,
  D_ARROW: 8,
  D_BARRACKS: 9,
  D_CANNON: 10,
  D_TESLA: 11,
  D_COIN: 12,
};
Ability_UiButtonImageType.names = {
  0: "UI_BUTTON_IMAGE_TYPE_UNKNOWN",
  1: "BARRACKS",
  2: "CANNON",
  3: "CANNON_V2",
  4: "CANNON_V3",
  5: "REPEATER_V1",
  6: "TESLA_V1",
  7: "TESLA_V2",
  8: "D_ARROW",
  9: "D_BARRACKS",
  10: "D_CANNON",
  11: "D_TESLA",
  12: "D_COIN",
};
export class Ability {
  get descriptor() {
    return Ability.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPrefix = false;
    this._prefix = null;
    this._hasTemplate = false;
    this._template = null;
    this._hasComment = false;
    this._comment = null;
    this._hasParent = false;
    this._parent = null;
    this._hasAbilityType = false;
    this._abilityType = null;
    this._hasCastType = false;
    this._castType = null;
    this._hasTargetRangeMode = false;
    this._targetRangeMode = null;
    this._hasEffect = false;
    this._effect = null;
    this._hasStats = false;
    this._stats = null;
    this._hasUseUnitCostDifference = false;
    this._useUnitCostDifference = null;
    this._hasAddToUnitCost = false;
    this._addToUnitCost = null;
    this._hasCost = false;
    this._cost = null;
    this._hasDeprecatedShow = false;
    this._show = null;
    this._hasPriority = false;
    this._priority = null;
    this._hasFamily = false;
    this._family = null;
    this._Validators = [];
    this._hasLevel = false;
    this._level = null;
    this._hasCanCastWhileMoving = false;
    this._canCastWhileMoving = null;
    this._hasIsRallyAbility = false;
    this._isRallyAbility = null;
    this._hasDisabled = false;
    this._disabled = null;
    this._hasHide = false;
    this._hide = null;
    this._hasDistanceCheckMode = false;
    this._distanceCheckMode = null;
    this._hasDistanceExtendMode = false;
    this._distanceExtendMode = null;
    this._hasTargetFilter = false;
    this._targetFilter = null;
    this._hasHighlight = false;
    this._highlight = null;
    this._abilityTags = [];
    this._hasChargeIgnoreCooldown = false;
    this._chargeIgnoreCooldown = null;
    this._hasShowChargeCountUi = false;
    this._showChargeCountUi = null;
    this._hasCriticalChance = false;
    this._criticalChance = null;
    this._hasCriticalEffect = false;
    this._criticalEffect = null;
    this._dependentUnits = [];
    this._dependentEffects = [];
    this._dependentBehaviors = [];
    this._hasDeprecatedUiButtonImage = false;
    this._uiButtonImage = null;
    this._hasDeprecatedUiButtonPosition = false;
    this._uiButtonPosition = null;
    this._hasCommandCardIndex = false;
    this._commandCardIndex = null;
    this._hasCommandCardIcon = false;
    this._commandCardIcon = null;
    this._hasCommandCardConfirmIcon = false;
    this._commandCardConfirmIcon = null;
    this._hasCommandCardDisplayText = false;
    this._commandCardDisplayText = null;
    this._hasCommandCardEnhancementIcon = false;
    this._commandCardEnhancementIcon = null;
    this._hasCommandCardOrnamentIcon = false;
    this._commandCardOrnamentIcon = null;
    this._hasPreserveMenu = false;
    this._preserveMenu = null;
    this._hasDescription = false;
    this._description = null;
    this._hasTitle = false;
    this._title = null;
    this._hasAffinityIndex = false;
    this._affinityIndex = null;
    this._hasCardName = false;
    this._cardName = null;
    this._hasTargetingValidCursorActor = false;
    this._targetingValidCursorActor = null;
    this._hasTargetingInvalidCursorActor = false;
    this._targetingInvalidCursorActor = null;
  }
  isEmpty() {
    if (this._hasPrefix) return false;
    if (this._hasTemplate) return false;
    if (this._hasComment) return false;
    if (this._hasParent) return false;
    if (this._hasAbilityType) return false;
    if (this._hasCastType) return false;
    if (this._hasTargetRangeMode) return false;
    if (this._hasEffect) return false;
    if (this._hasStats && !this._stats.isEmpty()) return false;
    if (this._hasUseUnitCostDifference) return false;
    if (this._hasAddToUnitCost) return false;
    if (this._hasCost && !this._cost.isEmpty()) return false;
    if (this._hasDeprecatedShow) return false;
    if (this._hasPriority) return false;
    if (this._hasFamily) return false;
    if (this._Validators.length > 0) return false;
    if (this._hasLevel) return false;
    if (this._hasCanCastWhileMoving) return false;
    if (this._hasIsRallyAbility) return false;
    if (this._hasDisabled) return false;
    if (this._hasHide) return false;
    if (this._hasDistanceCheckMode) return false;
    if (this._hasDistanceExtendMode) return false;
    if (this._hasTargetFilter && !this._targetFilter.isEmpty()) return false;
    if (this._hasHighlight) return false;
    if (this._abilityTags.length > 0) return false;
    if (this._hasChargeIgnoreCooldown) return false;
    if (this._hasShowChargeCountUi) return false;
    if (this._hasCriticalChance) return false;
    if (this._hasCriticalEffect) return false;
    if (this._dependentUnits.length > 0) return false;
    if (this._dependentEffects.length > 0) return false;
    if (this._dependentBehaviors.length > 0) return false;
    if (this._hasDeprecatedUiButtonImage) return false;
    if (this._hasDeprecatedUiButtonPosition) return false;
    if (this._hasCommandCardIndex) return false;
    if (this._hasCommandCardIcon) return false;
    if (this._hasCommandCardConfirmIcon) return false;
    if (this._hasCommandCardDisplayText) return false;
    if (this._hasCommandCardEnhancementIcon) return false;
    if (this._hasCommandCardOrnamentIcon) return false;
    if (this._hasPreserveMenu) return false;
    if (this._hasDescription) return false;
    if (this._hasTitle) return false;
    if (this._hasAffinityIndex) return false;
    if (this._hasCardName) return false;
    if (this._hasTargetingValidCursorActor) return false;
    if (this._hasTargetingInvalidCursorActor) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof Ability) {
      return value;
    }
    return Ability.fromJson(value);
  }
  static fromJson(json) {
    const result = new Ability();
    if (json.prefix != null) {
      result._hasPrefix = true;
      result._prefix = JsonToString.fromJson(json.prefix);
    }
    if (json.template != null) {
      result._hasTemplate = true;
      result._template = JsonToBoolean.fromJson(json.template);
    }
    if (json.comment != null) {
      result._hasComment = true;
      result._comment = JsonToString.fromJson(json.comment);
    }
    if (json.parent != null) {
      result._hasParent = true;
      result._parent = JsonToString.fromJson(json.parent);
    }
    if (json.abilityType != null) {
      result._hasAbilityType = true;
      result._abilityType = Ability_AbilityType.fromJson(json.abilityType);
    }
    if (json.castType != null) {
      result._hasCastType = true;
      result._castType = Ability_CastType.fromJson(json.castType);
    }
    if (json.targetRangeMode != null) {
      result._hasTargetRangeMode = true;
      result._targetRangeMode = Ability_TargetRangeModes.fromJson(json.targetRangeMode);
    }
    if (json.effect != null) {
      result._hasEffect = true;
      result._effect = JsonToString.fromJson(json.effect);
    }
    if (json.stats != null) {
      result._hasStats = true;
      result._stats = AbilityStats.fromJson(json.stats);
    }
    if (json.useUnitCostDifference != null) {
      result._hasUseUnitCostDifference = true;
      result._useUnitCostDifference = JsonToBoolean.fromJson(json.useUnitCostDifference);
    }
    if (json.addToUnitCost != null) {
      result._hasAddToUnitCost = true;
      result._addToUnitCost = JsonToBoolean.fromJson(json.addToUnitCost);
    }
    if (json.cost != null) {
      result._hasCost = true;
      result._cost = AbilityCost.fromJson(json.cost);
    }
    if (json.show != null) {
      result._hasDeprecatedShow = true;
      result._show = JsonToBoolean.fromJson(json.show);
    }
    if (json.priority != null) {
      result._hasPriority = true;
      result._priority = JsonToInt32.fromJson(json.priority);
    }
    if (json.family != null) {
      result._hasFamily = true;
      result._family = JsonToString.fromJson(json.family);
    }
    result._Validators = JsonToList(json.Validators, JsonToString);
    if (json.level != null) {
      result._hasLevel = true;
      result._level = JsonToInt32.fromJson(json.level);
    }
    if (json.canCastWhileMoving != null) {
      result._hasCanCastWhileMoving = true;
      result._canCastWhileMoving = JsonToBoolean.fromJson(json.canCastWhileMoving);
    }
    if (json.isRallyAbility != null) {
      result._hasIsRallyAbility = true;
      result._isRallyAbility = JsonToBoolean.fromJson(json.isRallyAbility);
    }
    if (json.disabled != null) {
      result._hasDisabled = true;
      result._disabled = JsonToBoolean.fromJson(json.disabled);
    }
    if (json.hide != null) {
      result._hasHide = true;
      result._hide = JsonToBoolean.fromJson(json.hide);
    }
    if (json.distanceCheckMode != null) {
      result._hasDistanceCheckMode = true;
      result._distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.fromJson(json.distanceCheckMode);
    }
    if (json.distanceExtendMode != null) {
      result._hasDistanceExtendMode = true;
      result._distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.fromJson(json.distanceExtendMode);
    }
    if (json.targetFilter != null) {
      result._hasTargetFilter = true;
      result._targetFilter = dcei_engine_effect_proto.SearchFilter.fromJson(json.targetFilter);
    }
    if (json.highlight != null) {
      result._hasHighlight = true;
      result._highlight = JsonToBoolean.fromJson(json.highlight);
    }
    result._abilityTags = JsonToList(json.abilityTags, JsonToString);
    if (json.chargeIgnoreCooldown != null) {
      result._hasChargeIgnoreCooldown = true;
      result._chargeIgnoreCooldown = JsonToBoolean.fromJson(json.chargeIgnoreCooldown);
    }
    if (json.showChargeCountUi != null) {
      result._hasShowChargeCountUi = true;
      result._showChargeCountUi = JsonToBoolean.fromJson(json.showChargeCountUi);
    }
    if (json.criticalChance != null) {
      result._hasCriticalChance = true;
      result._criticalChance = JsonToDouble.fromJson(json.criticalChance);
    }
    if (json.criticalEffect != null) {
      result._hasCriticalEffect = true;
      result._criticalEffect = JsonToString.fromJson(json.criticalEffect);
    }
    result._dependentUnits = JsonToList(json.dependentUnits, JsonToString);
    result._dependentEffects = JsonToList(json.dependentEffects, JsonToString);
    result._dependentBehaviors = JsonToList(json.dependentBehaviors, JsonToString);
    if (json.uiButtonImage != null) {
      result._hasDeprecatedUiButtonImage = true;
      result._uiButtonImage = Ability_UiButtonImageType.fromJson(json.uiButtonImage);
    }
    if (json.uiButtonPosition != null) {
      result._hasDeprecatedUiButtonPosition = true;
      result._uiButtonPosition = Ability_UiButtonPositionType.fromJson(json.uiButtonPosition);
    }
    if (json.commandCardIndex != null) {
      result._hasCommandCardIndex = true;
      result._commandCardIndex = JsonToInt32.fromJson(json.commandCardIndex);
    }
    if (json.commandCardIcon != null) {
      result._hasCommandCardIcon = true;
      result._commandCardIcon = JsonToString.fromJson(json.commandCardIcon);
    }
    if (json.commandCardConfirmIcon != null) {
      result._hasCommandCardConfirmIcon = true;
      result._commandCardConfirmIcon = JsonToString.fromJson(json.commandCardConfirmIcon);
    }
    if (json.commandCardDisplayText != null) {
      result._hasCommandCardDisplayText = true;
      result._commandCardDisplayText = JsonToString.fromJson(json.commandCardDisplayText);
    }
    if (json.commandCardEnhancementIcon != null) {
      result._hasCommandCardEnhancementIcon = true;
      result._commandCardEnhancementIcon = JsonToString.fromJson(json.commandCardEnhancementIcon);
    }
    if (json.commandCardOrnamentIcon != null) {
      result._hasCommandCardOrnamentIcon = true;
      result._commandCardOrnamentIcon = JsonToString.fromJson(json.commandCardOrnamentIcon);
    }
    if (json.preserveMenu != null) {
      result._hasPreserveMenu = true;
      result._preserveMenu = JsonToBoolean.fromJson(json.preserveMenu);
    }
    if (json.description != null) {
      result._hasDescription = true;
      result._description = JsonToString.fromJson(json.description);
    }
    if (json.title != null) {
      result._hasTitle = true;
      result._title = JsonToString.fromJson(json.title);
    }
    if (json.affinityIndex != null) {
      result._hasAffinityIndex = true;
      result._affinityIndex = JsonToInt32.fromJson(json.affinityIndex);
    }
    if (json.cardName != null) {
      result._hasCardName = true;
      result._cardName = JsonToString.fromJson(json.cardName);
    }
    if (json.targetingValidCursorActor != null) {
      result._hasTargetingValidCursorActor = true;
      result._targetingValidCursorActor = JsonToString.fromJson(json.targetingValidCursorActor);
    }
    if (json.targetingInvalidCursorActor != null) {
      result._hasTargetingInvalidCursorActor = true;
      result._targetingInvalidCursorActor = JsonToString.fromJson(json.targetingInvalidCursorActor);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPrefix) {
      result.prefix = JsonToString.toJson(this._prefix);
    }
    if (this._hasTemplate) {
      result.template = JsonToBoolean.toJson(this._template);
    }
    if (this._hasComment) {
      result.comment = JsonToString.toJson(this._comment);
    }
    if (this._hasParent) {
      result.parent = JsonToString.toJson(this._parent);
    }
    if (this._hasAbilityType) {
      result.abilityType = Ability_AbilityType.toJson(this._abilityType);
    }
    if (this._hasCastType) {
      result.castType = Ability_CastType.toJson(this._castType);
    }
    if (this._hasTargetRangeMode) {
      result.targetRangeMode = Ability_TargetRangeModes.toJson(this._targetRangeMode);
    }
    if (this._hasEffect) {
      result.effect = JsonToString.toJson(this._effect);
    }
    if (this._hasStats && !this._stats.isEmpty()) {
      result.stats = AbilityStats.toJson(this._stats);
    }
    if (this._hasUseUnitCostDifference) {
      result.useUnitCostDifference = JsonToBoolean.toJson(this._useUnitCostDifference);
    }
    if (this._hasAddToUnitCost) {
      result.addToUnitCost = JsonToBoolean.toJson(this._addToUnitCost);
    }
    if (this._hasCost && !this._cost.isEmpty()) {
      result.cost = AbilityCost.toJson(this._cost);
    }
    if (this._hasDeprecatedShow) {
      result.show = JsonToBoolean.toJson(this._show);
    }
    if (this._hasPriority) {
      result.priority = JsonToInt32.toJson(this._priority);
    }
    if (this._hasFamily) {
      result.family = JsonToString.toJson(this._family);
    }
    if (this._Validators.length > 0) {
      result.Validators = ArrayToJson(this._Validators, JsonToString);
    }
    if (this._hasLevel) {
      result.level = JsonToInt32.toJson(this._level);
    }
    if (this._hasCanCastWhileMoving) {
      result.canCastWhileMoving = JsonToBoolean.toJson(this._canCastWhileMoving);
    }
    if (this._hasIsRallyAbility) {
      result.isRallyAbility = JsonToBoolean.toJson(this._isRallyAbility);
    }
    if (this._hasDisabled) {
      result.disabled = JsonToBoolean.toJson(this._disabled);
    }
    if (this._hasHide) {
      result.hide = JsonToBoolean.toJson(this._hide);
    }
    if (this._hasDistanceCheckMode) {
      result.distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.toJson(this._distanceCheckMode);
    }
    if (this._hasDistanceExtendMode) {
      result.distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.toJson(this._distanceExtendMode);
    }
    if (this._hasTargetFilter && !this._targetFilter.isEmpty()) {
      result.targetFilter = dcei_engine_effect_proto.SearchFilter.toJson(this._targetFilter);
    }
    if (this._hasHighlight) {
      result.highlight = JsonToBoolean.toJson(this._highlight);
    }
    if (this._abilityTags.length > 0) {
      result.abilityTags = ArrayToJson(this._abilityTags, JsonToString);
    }
    if (this._hasChargeIgnoreCooldown) {
      result.chargeIgnoreCooldown = JsonToBoolean.toJson(this._chargeIgnoreCooldown);
    }
    if (this._hasShowChargeCountUi) {
      result.showChargeCountUi = JsonToBoolean.toJson(this._showChargeCountUi);
    }
    if (this._hasCriticalChance) {
      result.criticalChance = JsonToDouble.toJson(this._criticalChance);
    }
    if (this._hasCriticalEffect) {
      result.criticalEffect = JsonToString.toJson(this._criticalEffect);
    }
    if (this._dependentUnits.length > 0) {
      result.dependentUnits = ArrayToJson(this._dependentUnits, JsonToString);
    }
    if (this._dependentEffects.length > 0) {
      result.dependentEffects = ArrayToJson(this._dependentEffects, JsonToString);
    }
    if (this._dependentBehaviors.length > 0) {
      result.dependentBehaviors = ArrayToJson(this._dependentBehaviors, JsonToString);
    }
    if (this._hasDeprecatedUiButtonImage) {
      result.uiButtonImage = Ability_UiButtonImageType.toJson(this._uiButtonImage);
    }
    if (this._hasDeprecatedUiButtonPosition) {
      result.uiButtonPosition = Ability_UiButtonPositionType.toJson(this._uiButtonPosition);
    }
    if (this._hasCommandCardIndex) {
      result.commandCardIndex = JsonToInt32.toJson(this._commandCardIndex);
    }
    if (this._hasCommandCardIcon) {
      result.commandCardIcon = JsonToString.toJson(this._commandCardIcon);
    }
    if (this._hasCommandCardConfirmIcon) {
      result.commandCardConfirmIcon = JsonToString.toJson(this._commandCardConfirmIcon);
    }
    if (this._hasCommandCardDisplayText) {
      result.commandCardDisplayText = JsonToString.toJson(this._commandCardDisplayText);
    }
    if (this._hasCommandCardEnhancementIcon) {
      result.commandCardEnhancementIcon = JsonToString.toJson(this._commandCardEnhancementIcon);
    }
    if (this._hasCommandCardOrnamentIcon) {
      result.commandCardOrnamentIcon = JsonToString.toJson(this._commandCardOrnamentIcon);
    }
    if (this._hasPreserveMenu) {
      result.preserveMenu = JsonToBoolean.toJson(this._preserveMenu);
    }
    if (this._hasDescription) {
      result.description = JsonToString.toJson(this._description);
    }
    if (this._hasTitle) {
      result.title = JsonToString.toJson(this._title);
    }
    if (this._hasAffinityIndex) {
      result.affinityIndex = JsonToInt32.toJson(this._affinityIndex);
    }
    if (this._hasCardName) {
      result.cardName = JsonToString.toJson(this._cardName);
    }
    if (this._hasTargetingValidCursorActor) {
      result.targetingValidCursorActor = JsonToString.toJson(this._targetingValidCursorActor);
    }
    if (this._hasTargetingInvalidCursorActor) {
      result.targetingInvalidCursorActor = JsonToString.toJson(this._targetingInvalidCursorActor);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get prefix() {
    return this._hasPrefix ? this._prefix : JsonToString.default;
  }
  get hasPrefix() {
    return this._hasPrefix;
  }
  setPrefix(path, value) {
    return {type: 'SET', path: path.concat(['prefix']), value};
  }
  deletePrefix(path) {
    return {type: 'DELETE', path: path.concat(['prefix'])};
  }
  /**
   * @returns {boolean}
   */
  get template() {
    return this._hasTemplate ? this._template : JsonToBoolean.default;
  }
  get hasTemplate() {
    return this._hasTemplate;
  }
  setTemplate(path, value) {
    return {type: 'SET', path: path.concat(['template']), value};
  }
  deleteTemplate(path) {
    return {type: 'DELETE', path: path.concat(['template'])};
  }
  /**
   * @returns {string}
   */
  get comment() {
    return this._hasComment ? this._comment : JsonToString.default;
  }
  get hasComment() {
    return this._hasComment;
  }
  setComment(path, value) {
    return {type: 'SET', path: path.concat(['comment']), value};
  }
  deleteComment(path) {
    return {type: 'DELETE', path: path.concat(['comment'])};
  }
  /**
   * @returns {string}
   */
  get parent() {
    return this._hasParent ? this._parent : JsonToString.default;
  }
  get hasParent() {
    return this._hasParent;
  }
  setParent(path, value) {
    return {type: 'SET', path: path.concat(['parent']), value};
  }
  deleteParent(path) {
    return {type: 'DELETE', path: path.concat(['parent'])};
  }
  /**
   * @returns {number}
   */
  get abilityType() {
    return this._hasAbilityType ? this._abilityType : Ability_AbilityType.default;
  }
  get hasAbilityType() {
    return this._hasAbilityType;
  }
  setAbilityType(path, value) {
    return {type: 'SET', path: path.concat(['abilityType']), value};
  }
  deleteAbilityType(path) {
    return {type: 'DELETE', path: path.concat(['abilityType'])};
  }
  /**
   * @returns {number}
   */
  get castType() {
    return this._hasCastType ? this._castType : Ability_CastType.default;
  }
  get hasCastType() {
    return this._hasCastType;
  }
  setCastType(path, value) {
    return {type: 'SET', path: path.concat(['castType']), value};
  }
  deleteCastType(path) {
    return {type: 'DELETE', path: path.concat(['castType'])};
  }
  /**
   * @returns {number}
   */
  get targetRangeMode() {
    return this._hasTargetRangeMode ? this._targetRangeMode : Ability_TargetRangeModes.default;
  }
  get hasTargetRangeMode() {
    return this._hasTargetRangeMode;
  }
  setTargetRangeMode(path, value) {
    return {type: 'SET', path: path.concat(['targetRangeMode']), value};
  }
  deleteTargetRangeMode(path) {
    return {type: 'DELETE', path: path.concat(['targetRangeMode'])};
  }
  /**
   * @returns {string}
   */
  get effect() {
    return this._hasEffect ? this._effect : JsonToString.default;
  }
  get hasEffect() {
    return this._hasEffect;
  }
  setEffect(path, value) {
    return {type: 'SET', path: path.concat(['effect']), value};
  }
  deleteEffect(path) {
    return {type: 'DELETE', path: path.concat(['effect'])};
  }
  /**
   * @returns {AbilityStats}
   */
  get stats() {
    return this._hasStats ? this._stats : AbilityStats.default;
  }
  get hasStats() {
    return this._hasStats;
  }
  setStats(path, value) {
    return {type: 'SET', path: path.concat(['stats']), value: value.toJson()};
  }
  deleteStats(path) {
    return {type: 'DELETE', path: path.concat(['stats'])};
  }
  /**
   * @returns {boolean}
   */
  get useUnitCostDifference() {
    return this._hasUseUnitCostDifference ? this._useUnitCostDifference : JsonToBoolean.default;
  }
  get hasUseUnitCostDifference() {
    return this._hasUseUnitCostDifference;
  }
  setUseUnitCostDifference(path, value) {
    return {type: 'SET', path: path.concat(['useUnitCostDifference']), value};
  }
  deleteUseUnitCostDifference(path) {
    return {type: 'DELETE', path: path.concat(['useUnitCostDifference'])};
  }
  /**
   * @returns {boolean}
   */
  get addToUnitCost() {
    return this._hasAddToUnitCost ? this._addToUnitCost : JsonToBoolean.default;
  }
  get hasAddToUnitCost() {
    return this._hasAddToUnitCost;
  }
  setAddToUnitCost(path, value) {
    return {type: 'SET', path: path.concat(['addToUnitCost']), value};
  }
  deleteAddToUnitCost(path) {
    return {type: 'DELETE', path: path.concat(['addToUnitCost'])};
  }
  /**
   * @returns {AbilityCost}
   */
  get cost() {
    return this._hasCost ? this._cost : AbilityCost.default;
  }
  get hasCost() {
    return this._hasCost;
  }
  setCost(path, value) {
    return {type: 'SET', path: path.concat(['cost']), value: value.toJson()};
  }
  deleteCost(path) {
    return {type: 'DELETE', path: path.concat(['cost'])};
  }
  /**
   * @returns {boolean}
   */
  get show() {
    return this._hasDeprecatedShow ? this._show : JsonToBoolean.default;
  }
  get hasDeprecatedShow() {
    return this._hasDeprecatedShow;
  }
  setDeprecatedShow(path, value) {
    return {type: 'SET', path: path.concat(['show']), value};
  }
  deleteDeprecatedShow(path) {
    return {type: 'DELETE', path: path.concat(['show'])};
  }
  /**
   * @returns {number}
   */
  get priority() {
    return this._hasPriority ? this._priority : JsonToInt32.default;
  }
  get hasPriority() {
    return this._hasPriority;
  }
  setPriority(path, value) {
    return {type: 'SET', path: path.concat(['priority']), value};
  }
  deletePriority(path) {
    return {type: 'DELETE', path: path.concat(['priority'])};
  }
  /**
   * @returns {string}
   */
  get family() {
    return this._hasFamily ? this._family : JsonToString.default;
  }
  get hasFamily() {
    return this._hasFamily;
  }
  setFamily(path, value) {
    return {type: 'SET', path: path.concat(['family']), value};
  }
  deleteFamily(path) {
    return {type: 'DELETE', path: path.concat(['family'])};
  }
  /**
   * @returns {string[]}
   */
  get Validators() {
    return this._Validators;
  }
  addValidators(path, value) {
    return {type: 'ADD', path: path.concat(['Validators']), value};
  }
  setValidators(path, value) {
    return {type: 'SET', path: path.concat(['Validators']), value: ArrayToJson(value, JsonToString)};
  }
  setValidatorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['Validators', key]), value};
  }
  deleteValidators(path) {
    return {type: 'DELETE', path: path.concat(['Validators'])};
  }
  deleteValidatorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['Validators', key])};
  }
  /**
   * @returns {number}
   */
  get level() {
    return this._hasLevel ? this._level : JsonToInt32.default;
  }
  get hasLevel() {
    return this._hasLevel;
  }
  setLevel(path, value) {
    return {type: 'SET', path: path.concat(['level']), value};
  }
  deleteLevel(path) {
    return {type: 'DELETE', path: path.concat(['level'])};
  }
  /**
   * @returns {boolean}
   */
  get canCastWhileMoving() {
    return this._hasCanCastWhileMoving ? this._canCastWhileMoving : JsonToBoolean.default;
  }
  get hasCanCastWhileMoving() {
    return this._hasCanCastWhileMoving;
  }
  setCanCastWhileMoving(path, value) {
    return {type: 'SET', path: path.concat(['canCastWhileMoving']), value};
  }
  deleteCanCastWhileMoving(path) {
    return {type: 'DELETE', path: path.concat(['canCastWhileMoving'])};
  }
  /**
   * @returns {boolean}
   */
  get isRallyAbility() {
    return this._hasIsRallyAbility ? this._isRallyAbility : JsonToBoolean.default;
  }
  get hasIsRallyAbility() {
    return this._hasIsRallyAbility;
  }
  setIsRallyAbility(path, value) {
    return {type: 'SET', path: path.concat(['isRallyAbility']), value};
  }
  deleteIsRallyAbility(path) {
    return {type: 'DELETE', path: path.concat(['isRallyAbility'])};
  }
  /**
   * @returns {boolean}
   */
  get disabled() {
    return this._hasDisabled ? this._disabled : JsonToBoolean.default;
  }
  get hasDisabled() {
    return this._hasDisabled;
  }
  setDisabled(path, value) {
    return {type: 'SET', path: path.concat(['disabled']), value};
  }
  deleteDisabled(path) {
    return {type: 'DELETE', path: path.concat(['disabled'])};
  }
  /**
   * @returns {boolean}
   */
  get hide() {
    return this._hasHide ? this._hide : JsonToBoolean.default;
  }
  get hasHide() {
    return this._hasHide;
  }
  setHide(path, value) {
    return {type: 'SET', path: path.concat(['hide']), value};
  }
  deleteHide(path) {
    return {type: 'DELETE', path: path.concat(['hide'])};
  }
  /**
   * @returns {number}
   */
  get distanceCheckMode() {
    return this._hasDistanceCheckMode ? this._distanceCheckMode : dcei_engine_effect_proto.DistanceCheckModes.default;
  }
  get hasDistanceCheckMode() {
    return this._hasDistanceCheckMode;
  }
  setDistanceCheckMode(path, value) {
    return {type: 'SET', path: path.concat(['distanceCheckMode']), value};
  }
  deleteDistanceCheckMode(path) {
    return {type: 'DELETE', path: path.concat(['distanceCheckMode'])};
  }
  /**
   * @returns {number}
   */
  get distanceExtendMode() {
    return this._hasDistanceExtendMode ? this._distanceExtendMode : dcei_engine_effect_proto.DistanceExtendModes.default;
  }
  get hasDistanceExtendMode() {
    return this._hasDistanceExtendMode;
  }
  setDistanceExtendMode(path, value) {
    return {type: 'SET', path: path.concat(['distanceExtendMode']), value};
  }
  deleteDistanceExtendMode(path) {
    return {type: 'DELETE', path: path.concat(['distanceExtendMode'])};
  }
  /**
   * @returns {dcei_engine_effect_proto.SearchFilter}
   */
  get targetFilter() {
    return this._hasTargetFilter ? this._targetFilter : dcei_engine_effect_proto.SearchFilter.default;
  }
  get hasTargetFilter() {
    return this._hasTargetFilter;
  }
  setTargetFilter(path, value) {
    return {type: 'SET', path: path.concat(['targetFilter']), value: value.toJson()};
  }
  deleteTargetFilter(path) {
    return {type: 'DELETE', path: path.concat(['targetFilter'])};
  }
  /**
   * @returns {boolean}
   */
  get highlight() {
    return this._hasHighlight ? this._highlight : JsonToBoolean.default;
  }
  get hasHighlight() {
    return this._hasHighlight;
  }
  setHighlight(path, value) {
    return {type: 'SET', path: path.concat(['highlight']), value};
  }
  deleteHighlight(path) {
    return {type: 'DELETE', path: path.concat(['highlight'])};
  }
  /**
   * @returns {string[]}
   */
  get abilityTags() {
    return this._abilityTags;
  }
  addAbilityTags(path, value) {
    return {type: 'ADD', path: path.concat(['abilityTags']), value};
  }
  setAbilityTags(path, value) {
    return {type: 'SET', path: path.concat(['abilityTags']), value: ArrayToJson(value, JsonToString)};
  }
  setAbilityTagsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['abilityTags', key]), value};
  }
  deleteAbilityTags(path) {
    return {type: 'DELETE', path: path.concat(['abilityTags'])};
  }
  deleteAbilityTagsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['abilityTags', key])};
  }
  /**
   * @returns {boolean}
   */
  get chargeIgnoreCooldown() {
    return this._hasChargeIgnoreCooldown ? this._chargeIgnoreCooldown : JsonToBoolean.default;
  }
  get hasChargeIgnoreCooldown() {
    return this._hasChargeIgnoreCooldown;
  }
  setChargeIgnoreCooldown(path, value) {
    return {type: 'SET', path: path.concat(['chargeIgnoreCooldown']), value};
  }
  deleteChargeIgnoreCooldown(path) {
    return {type: 'DELETE', path: path.concat(['chargeIgnoreCooldown'])};
  }
  /**
   * @returns {boolean}
   */
  get showChargeCountUi() {
    return this._hasShowChargeCountUi ? this._showChargeCountUi : JsonToBoolean.default;
  }
  get hasShowChargeCountUi() {
    return this._hasShowChargeCountUi;
  }
  setShowChargeCountUi(path, value) {
    return {type: 'SET', path: path.concat(['showChargeCountUi']), value};
  }
  deleteShowChargeCountUi(path) {
    return {type: 'DELETE', path: path.concat(['showChargeCountUi'])};
  }
  /**
   * @returns {number}
   */
  get criticalChance() {
    return this._hasCriticalChance ? this._criticalChance : JsonToDouble.default;
  }
  get hasCriticalChance() {
    return this._hasCriticalChance;
  }
  setCriticalChance(path, value) {
    return {type: 'SET', path: path.concat(['criticalChance']), value};
  }
  deleteCriticalChance(path) {
    return {type: 'DELETE', path: path.concat(['criticalChance'])};
  }
  /**
   * @returns {string}
   */
  get criticalEffect() {
    return this._hasCriticalEffect ? this._criticalEffect : JsonToString.default;
  }
  get hasCriticalEffect() {
    return this._hasCriticalEffect;
  }
  setCriticalEffect(path, value) {
    return {type: 'SET', path: path.concat(['criticalEffect']), value};
  }
  deleteCriticalEffect(path) {
    return {type: 'DELETE', path: path.concat(['criticalEffect'])};
  }
  /**
   * @returns {string[]}
   */
  get dependentUnits() {
    return this._dependentUnits;
  }
  addDependentUnits(path, value) {
    return {type: 'ADD', path: path.concat(['dependentUnits']), value};
  }
  setDependentUnits(path, value) {
    return {type: 'SET', path: path.concat(['dependentUnits']), value: ArrayToJson(value, JsonToString)};
  }
  setDependentUnitsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dependentUnits', key]), value};
  }
  deleteDependentUnits(path) {
    return {type: 'DELETE', path: path.concat(['dependentUnits'])};
  }
  deleteDependentUnitsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dependentUnits', key])};
  }
  /**
   * @returns {string[]}
   */
  get dependentEffects() {
    return this._dependentEffects;
  }
  addDependentEffects(path, value) {
    return {type: 'ADD', path: path.concat(['dependentEffects']), value};
  }
  setDependentEffects(path, value) {
    return {type: 'SET', path: path.concat(['dependentEffects']), value: ArrayToJson(value, JsonToString)};
  }
  setDependentEffectsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dependentEffects', key]), value};
  }
  deleteDependentEffects(path) {
    return {type: 'DELETE', path: path.concat(['dependentEffects'])};
  }
  deleteDependentEffectsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dependentEffects', key])};
  }
  /**
   * @returns {string[]}
   */
  get dependentBehaviors() {
    return this._dependentBehaviors;
  }
  addDependentBehaviors(path, value) {
    return {type: 'ADD', path: path.concat(['dependentBehaviors']), value};
  }
  setDependentBehaviors(path, value) {
    return {type: 'SET', path: path.concat(['dependentBehaviors']), value: ArrayToJson(value, JsonToString)};
  }
  setDependentBehaviorsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['dependentBehaviors', key]), value};
  }
  deleteDependentBehaviors(path) {
    return {type: 'DELETE', path: path.concat(['dependentBehaviors'])};
  }
  deleteDependentBehaviorsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['dependentBehaviors', key])};
  }
  /**
   * @returns {number}
   */
  get uiButtonImage() {
    return this._hasDeprecatedUiButtonImage ? this._uiButtonImage : Ability_UiButtonImageType.default;
  }
  get hasDeprecatedUiButtonImage() {
    return this._hasDeprecatedUiButtonImage;
  }
  setDeprecatedUiButtonImage(path, value) {
    return {type: 'SET', path: path.concat(['uiButtonImage']), value};
  }
  deleteDeprecatedUiButtonImage(path) {
    return {type: 'DELETE', path: path.concat(['uiButtonImage'])};
  }
  /**
   * @returns {number}
   */
  get uiButtonPosition() {
    return this._hasDeprecatedUiButtonPosition ? this._uiButtonPosition : Ability_UiButtonPositionType.default;
  }
  get hasDeprecatedUiButtonPosition() {
    return this._hasDeprecatedUiButtonPosition;
  }
  setDeprecatedUiButtonPosition(path, value) {
    return {type: 'SET', path: path.concat(['uiButtonPosition']), value};
  }
  deleteDeprecatedUiButtonPosition(path) {
    return {type: 'DELETE', path: path.concat(['uiButtonPosition'])};
  }
  /**
   * @returns {number}
   */
  get commandCardIndex() {
    return this._hasCommandCardIndex ? this._commandCardIndex : JsonToInt32.default;
  }
  get hasCommandCardIndex() {
    return this._hasCommandCardIndex;
  }
  setCommandCardIndex(path, value) {
    return {type: 'SET', path: path.concat(['commandCardIndex']), value};
  }
  deleteCommandCardIndex(path) {
    return {type: 'DELETE', path: path.concat(['commandCardIndex'])};
  }
  /**
   * @returns {string}
   */
  get commandCardIcon() {
    return this._hasCommandCardIcon ? this._commandCardIcon : JsonToString.default;
  }
  get hasCommandCardIcon() {
    return this._hasCommandCardIcon;
  }
  setCommandCardIcon(path, value) {
    return {type: 'SET', path: path.concat(['commandCardIcon']), value};
  }
  deleteCommandCardIcon(path) {
    return {type: 'DELETE', path: path.concat(['commandCardIcon'])};
  }
  /**
   * @returns {string}
   */
  get commandCardConfirmIcon() {
    return this._hasCommandCardConfirmIcon ? this._commandCardConfirmIcon : JsonToString.default;
  }
  get hasCommandCardConfirmIcon() {
    return this._hasCommandCardConfirmIcon;
  }
  setCommandCardConfirmIcon(path, value) {
    return {type: 'SET', path: path.concat(['commandCardConfirmIcon']), value};
  }
  deleteCommandCardConfirmIcon(path) {
    return {type: 'DELETE', path: path.concat(['commandCardConfirmIcon'])};
  }
  /**
   * @returns {string}
   */
  get commandCardDisplayText() {
    return this._hasCommandCardDisplayText ? this._commandCardDisplayText : JsonToString.default;
  }
  get hasCommandCardDisplayText() {
    return this._hasCommandCardDisplayText;
  }
  setCommandCardDisplayText(path, value) {
    return {type: 'SET', path: path.concat(['commandCardDisplayText']), value};
  }
  deleteCommandCardDisplayText(path) {
    return {type: 'DELETE', path: path.concat(['commandCardDisplayText'])};
  }
  /**
   * @returns {string}
   */
  get commandCardEnhancementIcon() {
    return this._hasCommandCardEnhancementIcon ? this._commandCardEnhancementIcon : JsonToString.default;
  }
  get hasCommandCardEnhancementIcon() {
    return this._hasCommandCardEnhancementIcon;
  }
  setCommandCardEnhancementIcon(path, value) {
    return {type: 'SET', path: path.concat(['commandCardEnhancementIcon']), value};
  }
  deleteCommandCardEnhancementIcon(path) {
    return {type: 'DELETE', path: path.concat(['commandCardEnhancementIcon'])};
  }
  /**
   * @returns {string}
   */
  get commandCardOrnamentIcon() {
    return this._hasCommandCardOrnamentIcon ? this._commandCardOrnamentIcon : JsonToString.default;
  }
  get hasCommandCardOrnamentIcon() {
    return this._hasCommandCardOrnamentIcon;
  }
  setCommandCardOrnamentIcon(path, value) {
    return {type: 'SET', path: path.concat(['commandCardOrnamentIcon']), value};
  }
  deleteCommandCardOrnamentIcon(path) {
    return {type: 'DELETE', path: path.concat(['commandCardOrnamentIcon'])};
  }
  /**
   * @returns {boolean}
   */
  get preserveMenu() {
    return this._hasPreserveMenu ? this._preserveMenu : JsonToBoolean.default;
  }
  get hasPreserveMenu() {
    return this._hasPreserveMenu;
  }
  setPreserveMenu(path, value) {
    return {type: 'SET', path: path.concat(['preserveMenu']), value};
  }
  deletePreserveMenu(path) {
    return {type: 'DELETE', path: path.concat(['preserveMenu'])};
  }
  /**
   * @returns {string}
   */
  get description() {
    return this._hasDescription ? this._description : JsonToString.default;
  }
  get hasDescription() {
    return this._hasDescription;
  }
  setDescription(path, value) {
    return {type: 'SET', path: path.concat(['description']), value};
  }
  deleteDescription(path) {
    return {type: 'DELETE', path: path.concat(['description'])};
  }
  /**
   * @returns {string}
   */
  get title() {
    return this._hasTitle ? this._title : JsonToString.default;
  }
  get hasTitle() {
    return this._hasTitle;
  }
  setTitle(path, value) {
    return {type: 'SET', path: path.concat(['title']), value};
  }
  deleteTitle(path) {
    return {type: 'DELETE', path: path.concat(['title'])};
  }
  /**
   * @returns {number}
   */
  get affinityIndex() {
    return this._hasAffinityIndex ? this._affinityIndex : JsonToInt32.default;
  }
  get hasAffinityIndex() {
    return this._hasAffinityIndex;
  }
  setAffinityIndex(path, value) {
    return {type: 'SET', path: path.concat(['affinityIndex']), value};
  }
  deleteAffinityIndex(path) {
    return {type: 'DELETE', path: path.concat(['affinityIndex'])};
  }
  /**
   * @returns {string}
   */
  get cardName() {
    return this._hasCardName ? this._cardName : JsonToString.default;
  }
  get hasCardName() {
    return this._hasCardName;
  }
  setCardName(path, value) {
    return {type: 'SET', path: path.concat(['cardName']), value};
  }
  deleteCardName(path) {
    return {type: 'DELETE', path: path.concat(['cardName'])};
  }
  /**
   * @returns {string}
   */
  get targetingValidCursorActor() {
    return this._hasTargetingValidCursorActor ? this._targetingValidCursorActor : JsonToString.default;
  }
  get hasTargetingValidCursorActor() {
    return this._hasTargetingValidCursorActor;
  }
  setTargetingValidCursorActor(path, value) {
    return {type: 'SET', path: path.concat(['targetingValidCursorActor']), value};
  }
  deleteTargetingValidCursorActor(path) {
    return {type: 'DELETE', path: path.concat(['targetingValidCursorActor'])};
  }
  /**
   * @returns {string}
   */
  get targetingInvalidCursorActor() {
    return this._hasTargetingInvalidCursorActor ? this._targetingInvalidCursorActor : JsonToString.default;
  }
  get hasTargetingInvalidCursorActor() {
    return this._hasTargetingInvalidCursorActor;
  }
  setTargetingInvalidCursorActor(path, value) {
    return {type: 'SET', path: path.concat(['targetingInvalidCursorActor']), value};
  }
  deleteTargetingInvalidCursorActor(path) {
    return {type: 'DELETE', path: path.concat(['targetingInvalidCursorActor'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "prefix": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasPrefix = true;
              copy._prefix = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrefix) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasPrefix = false;
              copy._prefix = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "template": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasTemplate = true;
              copy._template = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTemplate) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasTemplate = false;
              copy._template = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "comment": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasComment = true;
              copy._comment = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasComment) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasComment = false;
              copy._comment = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "parent": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasParent = true;
              copy._parent = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasParent) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasParent = false;
              copy._parent = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "abilityType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasAbilityType = true;
              copy._abilityType = Ability_AbilityType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAbilityType) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasAbilityType = false;
              copy._abilityType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "castType": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCastType = true;
              copy._castType = Ability_CastType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCastType) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCastType = false;
              copy._castType = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetRangeMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasTargetRangeMode = true;
              copy._targetRangeMode = Ability_TargetRangeModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetRangeMode) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasTargetRangeMode = false;
              copy._targetRangeMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "effect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasEffect = true;
              copy._effect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasEffect) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasEffect = false;
              copy._effect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "stats": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasStats = true;
              copy._stats = AbilityStats.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasStats) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasStats = false;
              copy._stats = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasStats) {
            const copy = new Ability(this);
            copy._hasStats = true;
            copy._stats = AbilityStats.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._stats.apply(type, path.slice(1), value);
          if (newValue === this._stats) {
            return this;
          }
          const copy = new Ability(this);
          copy._stats = copy._stats.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "useUnitCostDifference": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasUseUnitCostDifference = true;
              copy._useUnitCostDifference = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseUnitCostDifference) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasUseUnitCostDifference = false;
              copy._useUnitCostDifference = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "addToUnitCost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasAddToUnitCost = true;
              copy._addToUnitCost = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAddToUnitCost) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasAddToUnitCost = false;
              copy._addToUnitCost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cost": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCost = true;
              copy._cost = AbilityCost.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCost) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCost = false;
              copy._cost = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasCost) {
            const copy = new Ability(this);
            copy._hasCost = true;
            copy._cost = AbilityCost.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._cost.apply(type, path.slice(1), value);
          if (newValue === this._cost) {
            return this;
          }
          const copy = new Ability(this);
          copy._cost = copy._cost.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "show": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasDeprecatedShow = true;
              copy._show = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedShow) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasDeprecatedShow = false;
              copy._show = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "priority": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasPriority = true;
              copy._priority = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPriority) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasPriority = false;
              copy._priority = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "family": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasFamily = true;
              copy._family = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFamily) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasFamily = false;
              copy._family = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "Validators": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._Validators = [];        for (let i of value) {
                copy._Validators.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Ability(this);
              copy._Validators = copy._Validators.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._Validators.length === 0) {
                return this;
              }
              const copy = new Ability(this);
              copy._Validators = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._Validators.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._Validators = copy._Validators.slice();
              copy._Validators[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Ability(this);
              copy._Validators = copy._Validators.slice(0, path[1]).concat(copy._Validators.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._Validators.length) {
            return this;
          }
          const oldValue = this._Validators[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Ability(this);
          copy._Validators = copy._Validators.slice();
          copy._Validators[key] = newValue;
          return copy;
        }
      }
      case "level": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasLevel = true;
              copy._level = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasLevel) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasLevel = false;
              copy._level = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "canCastWhileMoving": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCanCastWhileMoving = true;
              copy._canCastWhileMoving = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCanCastWhileMoving) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCanCastWhileMoving = false;
              copy._canCastWhileMoving = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "isRallyAbility": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasIsRallyAbility = true;
              copy._isRallyAbility = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasIsRallyAbility) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasIsRallyAbility = false;
              copy._isRallyAbility = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "disabled": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasDisabled = true;
              copy._disabled = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDisabled) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasDisabled = false;
              copy._disabled = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "hide": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasHide = true;
              copy._hide = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHide) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasHide = false;
              copy._hide = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "distanceCheckMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasDistanceCheckMode = true;
              copy._distanceCheckMode = dcei_engine_effect_proto.DistanceCheckModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDistanceCheckMode) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasDistanceCheckMode = false;
              copy._distanceCheckMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "distanceExtendMode": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasDistanceExtendMode = true;
              copy._distanceExtendMode = dcei_engine_effect_proto.DistanceExtendModes.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDistanceExtendMode) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasDistanceExtendMode = false;
              copy._distanceExtendMode = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetFilter": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasTargetFilter = true;
              copy._targetFilter = dcei_engine_effect_proto.SearchFilter.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetFilter) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasTargetFilter = false;
              copy._targetFilter = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          if (!this._hasTargetFilter) {
            const copy = new Ability(this);
            copy._hasTargetFilter = true;
            copy._targetFilter = dcei_engine_effect_proto.SearchFilter.default.apply(type, path.slice(1), value);
            return copy;
          }
          const newValue = this._targetFilter.apply(type, path.slice(1), value);
          if (newValue === this._targetFilter) {
            return this;
          }
          const copy = new Ability(this);
          copy._targetFilter = copy._targetFilter.apply(type, path.slice(1), value);
          return copy;
        }
      }
      case "highlight": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasHighlight = true;
              copy._highlight = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHighlight) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasHighlight = false;
              copy._highlight = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "abilityTags": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._abilityTags = [];        for (let i of value) {
                copy._abilityTags.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Ability(this);
              copy._abilityTags = copy._abilityTags.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._abilityTags.length === 0) {
                return this;
              }
              const copy = new Ability(this);
              copy._abilityTags = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._abilityTags.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._abilityTags = copy._abilityTags.slice();
              copy._abilityTags[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Ability(this);
              copy._abilityTags = copy._abilityTags.slice(0, path[1]).concat(copy._abilityTags.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._abilityTags.length) {
            return this;
          }
          const oldValue = this._abilityTags[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Ability(this);
          copy._abilityTags = copy._abilityTags.slice();
          copy._abilityTags[key] = newValue;
          return copy;
        }
      }
      case "chargeIgnoreCooldown": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasChargeIgnoreCooldown = true;
              copy._chargeIgnoreCooldown = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasChargeIgnoreCooldown) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasChargeIgnoreCooldown = false;
              copy._chargeIgnoreCooldown = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "showChargeCountUi": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasShowChargeCountUi = true;
              copy._showChargeCountUi = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasShowChargeCountUi) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasShowChargeCountUi = false;
              copy._showChargeCountUi = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "criticalChance": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCriticalChance = true;
              copy._criticalChance = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCriticalChance) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCriticalChance = false;
              copy._criticalChance = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "criticalEffect": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCriticalEffect = true;
              copy._criticalEffect = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCriticalEffect) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCriticalEffect = false;
              copy._criticalEffect = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "dependentUnits": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._dependentUnits = [];        for (let i of value) {
                copy._dependentUnits.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Ability(this);
              copy._dependentUnits = copy._dependentUnits.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dependentUnits.length === 0) {
                return this;
              }
              const copy = new Ability(this);
              copy._dependentUnits = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dependentUnits.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._dependentUnits = copy._dependentUnits.slice();
              copy._dependentUnits[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Ability(this);
              copy._dependentUnits = copy._dependentUnits.slice(0, path[1]).concat(copy._dependentUnits.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dependentUnits.length) {
            return this;
          }
          const oldValue = this._dependentUnits[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Ability(this);
          copy._dependentUnits = copy._dependentUnits.slice();
          copy._dependentUnits[key] = newValue;
          return copy;
        }
      }
      case "dependentEffects": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._dependentEffects = [];        for (let i of value) {
                copy._dependentEffects.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Ability(this);
              copy._dependentEffects = copy._dependentEffects.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dependentEffects.length === 0) {
                return this;
              }
              const copy = new Ability(this);
              copy._dependentEffects = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dependentEffects.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._dependentEffects = copy._dependentEffects.slice();
              copy._dependentEffects[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Ability(this);
              copy._dependentEffects = copy._dependentEffects.slice(0, path[1]).concat(copy._dependentEffects.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dependentEffects.length) {
            return this;
          }
          const oldValue = this._dependentEffects[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Ability(this);
          copy._dependentEffects = copy._dependentEffects.slice();
          copy._dependentEffects[key] = newValue;
          return copy;
        }
      }
      case "dependentBehaviors": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._dependentBehaviors = [];        for (let i of value) {
                copy._dependentBehaviors.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new Ability(this);
              copy._dependentBehaviors = copy._dependentBehaviors.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._dependentBehaviors.length === 0) {
                return this;
              }
              const copy = new Ability(this);
              copy._dependentBehaviors = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._dependentBehaviors.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._dependentBehaviors = copy._dependentBehaviors.slice();
              copy._dependentBehaviors[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new Ability(this);
              copy._dependentBehaviors = copy._dependentBehaviors.slice(0, path[1]).concat(copy._dependentBehaviors.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._dependentBehaviors.length) {
            return this;
          }
          const oldValue = this._dependentBehaviors[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new Ability(this);
          copy._dependentBehaviors = copy._dependentBehaviors.slice();
          copy._dependentBehaviors[key] = newValue;
          return copy;
        }
      }
      case "uiButtonImage": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasDeprecatedUiButtonImage = true;
              copy._uiButtonImage = Ability_UiButtonImageType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedUiButtonImage) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasDeprecatedUiButtonImage = false;
              copy._uiButtonImage = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "uiButtonPosition": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasDeprecatedUiButtonPosition = true;
              copy._uiButtonPosition = Ability_UiButtonPositionType.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDeprecatedUiButtonPosition) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasDeprecatedUiButtonPosition = false;
              copy._uiButtonPosition = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "commandCardIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCommandCardIndex = true;
              copy._commandCardIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCommandCardIndex) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCommandCardIndex = false;
              copy._commandCardIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "commandCardIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCommandCardIcon = true;
              copy._commandCardIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCommandCardIcon) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCommandCardIcon = false;
              copy._commandCardIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "commandCardConfirmIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCommandCardConfirmIcon = true;
              copy._commandCardConfirmIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCommandCardConfirmIcon) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCommandCardConfirmIcon = false;
              copy._commandCardConfirmIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "commandCardDisplayText": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCommandCardDisplayText = true;
              copy._commandCardDisplayText = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCommandCardDisplayText) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCommandCardDisplayText = false;
              copy._commandCardDisplayText = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "commandCardEnhancementIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCommandCardEnhancementIcon = true;
              copy._commandCardEnhancementIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCommandCardEnhancementIcon) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCommandCardEnhancementIcon = false;
              copy._commandCardEnhancementIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "commandCardOrnamentIcon": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCommandCardOrnamentIcon = true;
              copy._commandCardOrnamentIcon = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCommandCardOrnamentIcon) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCommandCardOrnamentIcon = false;
              copy._commandCardOrnamentIcon = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "preserveMenu": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasPreserveMenu = true;
              copy._preserveMenu = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPreserveMenu) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasPreserveMenu = false;
              copy._preserveMenu = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "description": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasDescription = true;
              copy._description = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasDescription) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasDescription = false;
              copy._description = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "title": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasTitle = true;
              copy._title = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTitle) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasTitle = false;
              copy._title = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "affinityIndex": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasAffinityIndex = true;
              copy._affinityIndex = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasAffinityIndex) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasAffinityIndex = false;
              copy._affinityIndex = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "cardName": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasCardName = true;
              copy._cardName = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCardName) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasCardName = false;
              copy._cardName = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetingValidCursorActor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasTargetingValidCursorActor = true;
              copy._targetingValidCursorActor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetingValidCursorActor) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasTargetingValidCursorActor = false;
              copy._targetingValidCursorActor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "targetingInvalidCursorActor": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new Ability(this);
              copy._hasTargetingInvalidCursorActor = true;
              copy._targetingInvalidCursorActor = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasTargetingInvalidCursorActor) {
                return this;
              }
              const copy = new Ability(this);
              copy._hasTargetingInvalidCursorActor = false;
              copy._targetingInvalidCursorActor = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {Ability} other
   * @returns {Ability}
   */
  merge(other) {
    const copy = new Ability(this);
    if (other._hasPrefix) {
      copy._hasPrefix = true;
      copy._prefix = other._prefix;
    }
    if (other._hasTemplate) {
      copy._hasTemplate = true;
      copy._template = other._template;
    }
    if (other._hasComment) {
      copy._hasComment = true;
      copy._comment = other._comment;
    }
    if (other._hasParent) {
      copy._hasParent = true;
      copy._parent = other._parent;
    }
    if (other._hasAbilityType) {
      copy._hasAbilityType = true;
      copy._abilityType = other._abilityType;
    }
    if (other._hasCastType) {
      copy._hasCastType = true;
      copy._castType = other._castType;
    }
    if (other._hasTargetRangeMode) {
      copy._hasTargetRangeMode = true;
      copy._targetRangeMode = other._targetRangeMode;
    }
    if (other._hasEffect) {
      copy._hasEffect = true;
      copy._effect = other._effect;
    }
    if (other._hasStats) {
      if (copy._hasStats) {
        copy._stats = copy.stats.merge(other.stats);
      } else {
        copy._stats = other._stats;
      }
      copy._hasStats = true;
    }
    if (other._hasUseUnitCostDifference) {
      copy._hasUseUnitCostDifference = true;
      copy._useUnitCostDifference = other._useUnitCostDifference;
    }
    if (other._hasAddToUnitCost) {
      copy._hasAddToUnitCost = true;
      copy._addToUnitCost = other._addToUnitCost;
    }
    if (other._hasCost) {
      if (copy._hasCost) {
        copy._cost = copy.cost.merge(other.cost);
      } else {
        copy._cost = other._cost;
      }
      copy._hasCost = true;
    }
    if (other._hasDeprecatedShow) {
      copy._hasDeprecatedShow = true;
      copy._show = other._show;
    }
    if (other._hasPriority) {
      copy._hasPriority = true;
      copy._priority = other._priority;
    }
    if (other._hasFamily) {
      copy._hasFamily = true;
      copy._family = other._family;
    }
    copy._Validators = this._Validators.concat(other._Validators);
    if (other._hasLevel) {
      copy._hasLevel = true;
      copy._level = other._level;
    }
    if (other._hasCanCastWhileMoving) {
      copy._hasCanCastWhileMoving = true;
      copy._canCastWhileMoving = other._canCastWhileMoving;
    }
    if (other._hasIsRallyAbility) {
      copy._hasIsRallyAbility = true;
      copy._isRallyAbility = other._isRallyAbility;
    }
    if (other._hasDisabled) {
      copy._hasDisabled = true;
      copy._disabled = other._disabled;
    }
    if (other._hasHide) {
      copy._hasHide = true;
      copy._hide = other._hide;
    }
    if (other._hasDistanceCheckMode) {
      copy._hasDistanceCheckMode = true;
      copy._distanceCheckMode = other._distanceCheckMode;
    }
    if (other._hasDistanceExtendMode) {
      copy._hasDistanceExtendMode = true;
      copy._distanceExtendMode = other._distanceExtendMode;
    }
    if (other._hasTargetFilter) {
      if (copy._hasTargetFilter) {
        copy._targetFilter = copy.targetFilter.merge(other.targetFilter);
      } else {
        copy._targetFilter = other._targetFilter;
      }
      copy._hasTargetFilter = true;
    }
    if (other._hasHighlight) {
      copy._hasHighlight = true;
      copy._highlight = other._highlight;
    }
    copy._abilityTags = this._abilityTags.concat(other._abilityTags);
    if (other._hasChargeIgnoreCooldown) {
      copy._hasChargeIgnoreCooldown = true;
      copy._chargeIgnoreCooldown = other._chargeIgnoreCooldown;
    }
    if (other._hasShowChargeCountUi) {
      copy._hasShowChargeCountUi = true;
      copy._showChargeCountUi = other._showChargeCountUi;
    }
    if (other._hasCriticalChance) {
      copy._hasCriticalChance = true;
      copy._criticalChance = other._criticalChance;
    }
    if (other._hasCriticalEffect) {
      copy._hasCriticalEffect = true;
      copy._criticalEffect = other._criticalEffect;
    }
    copy._dependentUnits = this._dependentUnits.concat(other._dependentUnits);
    copy._dependentEffects = this._dependentEffects.concat(other._dependentEffects);
    copy._dependentBehaviors = this._dependentBehaviors.concat(other._dependentBehaviors);
    if (other._hasDeprecatedUiButtonImage) {
      copy._hasDeprecatedUiButtonImage = true;
      copy._uiButtonImage = other._uiButtonImage;
    }
    if (other._hasDeprecatedUiButtonPosition) {
      copy._hasDeprecatedUiButtonPosition = true;
      copy._uiButtonPosition = other._uiButtonPosition;
    }
    if (other._hasCommandCardIndex) {
      copy._hasCommandCardIndex = true;
      copy._commandCardIndex = other._commandCardIndex;
    }
    if (other._hasCommandCardIcon) {
      copy._hasCommandCardIcon = true;
      copy._commandCardIcon = other._commandCardIcon;
    }
    if (other._hasCommandCardConfirmIcon) {
      copy._hasCommandCardConfirmIcon = true;
      copy._commandCardConfirmIcon = other._commandCardConfirmIcon;
    }
    if (other._hasCommandCardDisplayText) {
      copy._hasCommandCardDisplayText = true;
      copy._commandCardDisplayText = other._commandCardDisplayText;
    }
    if (other._hasCommandCardEnhancementIcon) {
      copy._hasCommandCardEnhancementIcon = true;
      copy._commandCardEnhancementIcon = other._commandCardEnhancementIcon;
    }
    if (other._hasCommandCardOrnamentIcon) {
      copy._hasCommandCardOrnamentIcon = true;
      copy._commandCardOrnamentIcon = other._commandCardOrnamentIcon;
    }
    if (other._hasPreserveMenu) {
      copy._hasPreserveMenu = true;
      copy._preserveMenu = other._preserveMenu;
    }
    if (other._hasDescription) {
      copy._hasDescription = true;
      copy._description = other._description;
    }
    if (other._hasTitle) {
      copy._hasTitle = true;
      copy._title = other._title;
    }
    if (other._hasAffinityIndex) {
      copy._hasAffinityIndex = true;
      copy._affinityIndex = other._affinityIndex;
    }
    if (other._hasCardName) {
      copy._hasCardName = true;
      copy._cardName = other._cardName;
    }
    if (other._hasTargetingValidCursorActor) {
      copy._hasTargetingValidCursorActor = true;
      copy._targetingValidCursorActor = other._targetingValidCursorActor;
    }
    if (other._hasTargetingInvalidCursorActor) {
      copy._hasTargetingInvalidCursorActor = true;
      copy._targetingInvalidCursorActor = other._targetingInvalidCursorActor;
    }
    return copy;
  }
}
Ability.default = new Ability();
Ability.AbilityType = Ability_AbilityType;
Ability.CastType = Ability_CastType;
Ability.TargetRangeModes = Ability_TargetRangeModes;
Ability.UiButtonPositionType = Ability_UiButtonPositionType;
Ability.UiButtonImageType = Ability_UiButtonImageType;
class Ability_Builder {
  constructor(value) {
    this._value = new Ability(value);
  }
  build() {
    return new Ability(this._value);
  }
  setPrefix(value) {
    this._value._hasPrefix = true;
    this._value._prefix = value;
    return this;
  }
  deletePrefix() {
    this._value._hasPrefix = false;
    this._value._prefix = null;
    return this;
  }
  setTemplate(value) {
    this._value._hasTemplate = true;
    this._value._template = value;
    return this;
  }
  deleteTemplate() {
    this._value._hasTemplate = false;
    this._value._template = null;
    return this;
  }
  setComment(value) {
    this._value._hasComment = true;
    this._value._comment = value;
    return this;
  }
  deleteComment() {
    this._value._hasComment = false;
    this._value._comment = null;
    return this;
  }
  setParent(value) {
    this._value._hasParent = true;
    this._value._parent = value;
    return this;
  }
  deleteParent() {
    this._value._hasParent = false;
    this._value._parent = null;
    return this;
  }
  setAbilityType(value) {
    this._value._hasAbilityType = true;
    this._value._abilityType = value;
    return this;
  }
  deleteAbilityType() {
    this._value._hasAbilityType = false;
    this._value._abilityType = null;
    return this;
  }
  setCastType(value) {
    this._value._hasCastType = true;
    this._value._castType = value;
    return this;
  }
  deleteCastType() {
    this._value._hasCastType = false;
    this._value._castType = null;
    return this;
  }
  setTargetRangeMode(value) {
    this._value._hasTargetRangeMode = true;
    this._value._targetRangeMode = value;
    return this;
  }
  deleteTargetRangeMode() {
    this._value._hasTargetRangeMode = false;
    this._value._targetRangeMode = null;
    return this;
  }
  setEffect(value) {
    this._value._hasEffect = true;
    this._value._effect = value;
    return this;
  }
  deleteEffect() {
    this._value._hasEffect = false;
    this._value._effect = null;
    return this;
  }
  setStats(value) {
    this._value._hasStats = true;
    this._value._stats = value;
    return this;
  }
  deleteStats() {
    this._value._hasStats = false;
    this._value._stats = null;
    return this;
  }
  setUseUnitCostDifference(value) {
    this._value._hasUseUnitCostDifference = true;
    this._value._useUnitCostDifference = value;
    return this;
  }
  deleteUseUnitCostDifference() {
    this._value._hasUseUnitCostDifference = false;
    this._value._useUnitCostDifference = null;
    return this;
  }
  setAddToUnitCost(value) {
    this._value._hasAddToUnitCost = true;
    this._value._addToUnitCost = value;
    return this;
  }
  deleteAddToUnitCost() {
    this._value._hasAddToUnitCost = false;
    this._value._addToUnitCost = null;
    return this;
  }
  setCost(value) {
    this._value._hasCost = true;
    this._value._cost = value;
    return this;
  }
  deleteCost() {
    this._value._hasCost = false;
    this._value._cost = null;
    return this;
  }
  setDeprecatedShow(value) {
    this._value._hasDeprecatedShow = true;
    this._value._show = value;
    return this;
  }
  deleteDeprecatedShow() {
    this._value._hasDeprecatedShow = false;
    this._value._show = null;
    return this;
  }
  setPriority(value) {
    this._value._hasPriority = true;
    this._value._priority = value;
    return this;
  }
  deletePriority() {
    this._value._hasPriority = false;
    this._value._priority = null;
    return this;
  }
  setFamily(value) {
    this._value._hasFamily = true;
    this._value._family = value;
    return this;
  }
  deleteFamily() {
    this._value._hasFamily = false;
    this._value._family = null;
    return this;
  }
  addAllValidators(values) {
    this._value._Validators = this._value._Validators.concat(values);
    return this;
  }
  addValidators(value) {
    this._value._Validators = this._value._Validators.concat([value]);
    return this;
  }
  setValidators(index, value) {
    this._value._Validators = this._value._Validators.concat();
    this._value._Validators[index] = value;
    return this;
  }
  clearValidators() {
    this._value._Validators = [];
    return this;
  }
  setLevel(value) {
    this._value._hasLevel = true;
    this._value._level = value;
    return this;
  }
  deleteLevel() {
    this._value._hasLevel = false;
    this._value._level = null;
    return this;
  }
  setCanCastWhileMoving(value) {
    this._value._hasCanCastWhileMoving = true;
    this._value._canCastWhileMoving = value;
    return this;
  }
  deleteCanCastWhileMoving() {
    this._value._hasCanCastWhileMoving = false;
    this._value._canCastWhileMoving = null;
    return this;
  }
  setIsRallyAbility(value) {
    this._value._hasIsRallyAbility = true;
    this._value._isRallyAbility = value;
    return this;
  }
  deleteIsRallyAbility() {
    this._value._hasIsRallyAbility = false;
    this._value._isRallyAbility = null;
    return this;
  }
  setDisabled(value) {
    this._value._hasDisabled = true;
    this._value._disabled = value;
    return this;
  }
  deleteDisabled() {
    this._value._hasDisabled = false;
    this._value._disabled = null;
    return this;
  }
  setHide(value) {
    this._value._hasHide = true;
    this._value._hide = value;
    return this;
  }
  deleteHide() {
    this._value._hasHide = false;
    this._value._hide = null;
    return this;
  }
  setDistanceCheckMode(value) {
    this._value._hasDistanceCheckMode = true;
    this._value._distanceCheckMode = value;
    return this;
  }
  deleteDistanceCheckMode() {
    this._value._hasDistanceCheckMode = false;
    this._value._distanceCheckMode = null;
    return this;
  }
  setDistanceExtendMode(value) {
    this._value._hasDistanceExtendMode = true;
    this._value._distanceExtendMode = value;
    return this;
  }
  deleteDistanceExtendMode() {
    this._value._hasDistanceExtendMode = false;
    this._value._distanceExtendMode = null;
    return this;
  }
  setTargetFilter(value) {
    this._value._hasTargetFilter = true;
    this._value._targetFilter = value;
    return this;
  }
  deleteTargetFilter() {
    this._value._hasTargetFilter = false;
    this._value._targetFilter = null;
    return this;
  }
  setHighlight(value) {
    this._value._hasHighlight = true;
    this._value._highlight = value;
    return this;
  }
  deleteHighlight() {
    this._value._hasHighlight = false;
    this._value._highlight = null;
    return this;
  }
  addAllAbilityTags(values) {
    this._value._abilityTags = this._value._abilityTags.concat(values);
    return this;
  }
  addAbilityTags(value) {
    this._value._abilityTags = this._value._abilityTags.concat([value]);
    return this;
  }
  setAbilityTags(index, value) {
    this._value._abilityTags = this._value._abilityTags.concat();
    this._value._abilityTags[index] = value;
    return this;
  }
  clearAbilityTags() {
    this._value._abilityTags = [];
    return this;
  }
  setChargeIgnoreCooldown(value) {
    this._value._hasChargeIgnoreCooldown = true;
    this._value._chargeIgnoreCooldown = value;
    return this;
  }
  deleteChargeIgnoreCooldown() {
    this._value._hasChargeIgnoreCooldown = false;
    this._value._chargeIgnoreCooldown = null;
    return this;
  }
  setShowChargeCountUi(value) {
    this._value._hasShowChargeCountUi = true;
    this._value._showChargeCountUi = value;
    return this;
  }
  deleteShowChargeCountUi() {
    this._value._hasShowChargeCountUi = false;
    this._value._showChargeCountUi = null;
    return this;
  }
  setCriticalChance(value) {
    this._value._hasCriticalChance = true;
    this._value._criticalChance = value;
    return this;
  }
  deleteCriticalChance() {
    this._value._hasCriticalChance = false;
    this._value._criticalChance = null;
    return this;
  }
  setCriticalEffect(value) {
    this._value._hasCriticalEffect = true;
    this._value._criticalEffect = value;
    return this;
  }
  deleteCriticalEffect() {
    this._value._hasCriticalEffect = false;
    this._value._criticalEffect = null;
    return this;
  }
  addAllDependentUnits(values) {
    this._value._dependentUnits = this._value._dependentUnits.concat(values);
    return this;
  }
  addDependentUnits(value) {
    this._value._dependentUnits = this._value._dependentUnits.concat([value]);
    return this;
  }
  setDependentUnits(index, value) {
    this._value._dependentUnits = this._value._dependentUnits.concat();
    this._value._dependentUnits[index] = value;
    return this;
  }
  clearDependentUnits() {
    this._value._dependentUnits = [];
    return this;
  }
  addAllDependentEffects(values) {
    this._value._dependentEffects = this._value._dependentEffects.concat(values);
    return this;
  }
  addDependentEffects(value) {
    this._value._dependentEffects = this._value._dependentEffects.concat([value]);
    return this;
  }
  setDependentEffects(index, value) {
    this._value._dependentEffects = this._value._dependentEffects.concat();
    this._value._dependentEffects[index] = value;
    return this;
  }
  clearDependentEffects() {
    this._value._dependentEffects = [];
    return this;
  }
  addAllDependentBehaviors(values) {
    this._value._dependentBehaviors = this._value._dependentBehaviors.concat(values);
    return this;
  }
  addDependentBehaviors(value) {
    this._value._dependentBehaviors = this._value._dependentBehaviors.concat([value]);
    return this;
  }
  setDependentBehaviors(index, value) {
    this._value._dependentBehaviors = this._value._dependentBehaviors.concat();
    this._value._dependentBehaviors[index] = value;
    return this;
  }
  clearDependentBehaviors() {
    this._value._dependentBehaviors = [];
    return this;
  }
  setDeprecatedUiButtonImage(value) {
    this._value._hasDeprecatedUiButtonImage = true;
    this._value._uiButtonImage = value;
    return this;
  }
  deleteDeprecatedUiButtonImage() {
    this._value._hasDeprecatedUiButtonImage = false;
    this._value._uiButtonImage = null;
    return this;
  }
  setDeprecatedUiButtonPosition(value) {
    this._value._hasDeprecatedUiButtonPosition = true;
    this._value._uiButtonPosition = value;
    return this;
  }
  deleteDeprecatedUiButtonPosition() {
    this._value._hasDeprecatedUiButtonPosition = false;
    this._value._uiButtonPosition = null;
    return this;
  }
  setCommandCardIndex(value) {
    this._value._hasCommandCardIndex = true;
    this._value._commandCardIndex = value;
    return this;
  }
  deleteCommandCardIndex() {
    this._value._hasCommandCardIndex = false;
    this._value._commandCardIndex = null;
    return this;
  }
  setCommandCardIcon(value) {
    this._value._hasCommandCardIcon = true;
    this._value._commandCardIcon = value;
    return this;
  }
  deleteCommandCardIcon() {
    this._value._hasCommandCardIcon = false;
    this._value._commandCardIcon = null;
    return this;
  }
  setCommandCardConfirmIcon(value) {
    this._value._hasCommandCardConfirmIcon = true;
    this._value._commandCardConfirmIcon = value;
    return this;
  }
  deleteCommandCardConfirmIcon() {
    this._value._hasCommandCardConfirmIcon = false;
    this._value._commandCardConfirmIcon = null;
    return this;
  }
  setCommandCardDisplayText(value) {
    this._value._hasCommandCardDisplayText = true;
    this._value._commandCardDisplayText = value;
    return this;
  }
  deleteCommandCardDisplayText() {
    this._value._hasCommandCardDisplayText = false;
    this._value._commandCardDisplayText = null;
    return this;
  }
  setCommandCardEnhancementIcon(value) {
    this._value._hasCommandCardEnhancementIcon = true;
    this._value._commandCardEnhancementIcon = value;
    return this;
  }
  deleteCommandCardEnhancementIcon() {
    this._value._hasCommandCardEnhancementIcon = false;
    this._value._commandCardEnhancementIcon = null;
    return this;
  }
  setCommandCardOrnamentIcon(value) {
    this._value._hasCommandCardOrnamentIcon = true;
    this._value._commandCardOrnamentIcon = value;
    return this;
  }
  deleteCommandCardOrnamentIcon() {
    this._value._hasCommandCardOrnamentIcon = false;
    this._value._commandCardOrnamentIcon = null;
    return this;
  }
  setPreserveMenu(value) {
    this._value._hasPreserveMenu = true;
    this._value._preserveMenu = value;
    return this;
  }
  deletePreserveMenu() {
    this._value._hasPreserveMenu = false;
    this._value._preserveMenu = null;
    return this;
  }
  setDescription(value) {
    this._value._hasDescription = true;
    this._value._description = value;
    return this;
  }
  deleteDescription() {
    this._value._hasDescription = false;
    this._value._description = null;
    return this;
  }
  setTitle(value) {
    this._value._hasTitle = true;
    this._value._title = value;
    return this;
  }
  deleteTitle() {
    this._value._hasTitle = false;
    this._value._title = null;
    return this;
  }
  setAffinityIndex(value) {
    this._value._hasAffinityIndex = true;
    this._value._affinityIndex = value;
    return this;
  }
  deleteAffinityIndex() {
    this._value._hasAffinityIndex = false;
    this._value._affinityIndex = null;
    return this;
  }
  setCardName(value) {
    this._value._hasCardName = true;
    this._value._cardName = value;
    return this;
  }
  deleteCardName() {
    this._value._hasCardName = false;
    this._value._cardName = null;
    return this;
  }
  setTargetingValidCursorActor(value) {
    this._value._hasTargetingValidCursorActor = true;
    this._value._targetingValidCursorActor = value;
    return this;
  }
  deleteTargetingValidCursorActor() {
    this._value._hasTargetingValidCursorActor = false;
    this._value._targetingValidCursorActor = null;
    return this;
  }
  setTargetingInvalidCursorActor(value) {
    this._value._hasTargetingInvalidCursorActor = true;
    this._value._targetingInvalidCursorActor = value;
    return this;
  }
  deleteTargetingInvalidCursorActor() {
    this._value._hasTargetingInvalidCursorActor = false;
    this._value._targetingInvalidCursorActor = null;
    return this;
  }
}
Ability.Builder = Ability_Builder;
class Ability_WithParent {
  /**
   * @param {Ability} value
   * @param {Ability_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return Ability.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPrefix() {
    if (this._cachedHasPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedHasPrefix = true;
      } else {
        this._cachedHasPrefix = this._parent ? this._parent.hasPrefix : false;
      }
    }
    return this._cachedHasPrefix;
  }
  get prefix() {
    if (this._cachedPrefix === undefined) {
      if (this._value.hasPrefix) {
        this._cachedPrefix = this._value.prefix;
      } else {
        this._cachedPrefix = this._parent ? this._parent.prefix : this._value.prefix;
      }
    }
    return this._cachedPrefix;
  }
  get hasTemplate() {
    if (this._cachedHasTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedHasTemplate = true;
      } else {
        this._cachedHasTemplate = this._parent ? this._parent.hasTemplate : false;
      }
    }
    return this._cachedHasTemplate;
  }
  get template() {
    if (this._cachedTemplate === undefined) {
      if (this._value.hasTemplate) {
        this._cachedTemplate = this._value.template;
      } else {
        this._cachedTemplate = this._parent ? this._parent.template : this._value.template;
      }
    }
    return this._cachedTemplate;
  }
  get hasComment() {
    if (this._cachedHasComment === undefined) {
      if (this._value.hasComment) {
        this._cachedHasComment = true;
      } else {
        this._cachedHasComment = this._parent ? this._parent.hasComment : false;
      }
    }
    return this._cachedHasComment;
  }
  get comment() {
    if (this._cachedComment === undefined) {
      if (this._value.hasComment) {
        this._cachedComment = this._value.comment;
      } else {
        this._cachedComment = this._parent ? this._parent.comment : this._value.comment;
      }
    }
    return this._cachedComment;
  }
  get hasParent() {
    if (this._cachedHasParent === undefined) {
      if (this._value.hasParent) {
        this._cachedHasParent = true;
      } else {
        this._cachedHasParent = this._parent ? this._parent.hasParent : false;
      }
    }
    return this._cachedHasParent;
  }
  get parent() {
    if (this._cachedParent === undefined) {
      if (this._value.hasParent) {
        this._cachedParent = this._value.parent;
      } else {
        this._cachedParent = this._parent ? this._parent.parent : this._value.parent;
      }
    }
    return this._cachedParent;
  }
  get hasAbilityType() {
    if (this._cachedHasAbilityType === undefined) {
      if (this._value.hasAbilityType) {
        this._cachedHasAbilityType = true;
      } else {
        this._cachedHasAbilityType = this._parent ? this._parent.hasAbilityType : false;
      }
    }
    return this._cachedHasAbilityType;
  }
  get abilityType() {
    if (this._cachedAbilityType === undefined) {
      if (this._value.hasAbilityType) {
        this._cachedAbilityType = this._value.abilityType;
      } else {
        this._cachedAbilityType = this._parent ? this._parent.abilityType : this._value.abilityType;
      }
    }
    return this._cachedAbilityType;
  }
  get hasCastType() {
    if (this._cachedHasCastType === undefined) {
      if (this._value.hasCastType) {
        this._cachedHasCastType = true;
      } else {
        this._cachedHasCastType = this._parent ? this._parent.hasCastType : false;
      }
    }
    return this._cachedHasCastType;
  }
  get castType() {
    if (this._cachedCastType === undefined) {
      if (this._value.hasCastType) {
        this._cachedCastType = this._value.castType;
      } else {
        this._cachedCastType = this._parent ? this._parent.castType : this._value.castType;
      }
    }
    return this._cachedCastType;
  }
  get hasTargetRangeMode() {
    if (this._cachedHasTargetRangeMode === undefined) {
      if (this._value.hasTargetRangeMode) {
        this._cachedHasTargetRangeMode = true;
      } else {
        this._cachedHasTargetRangeMode = this._parent ? this._parent.hasTargetRangeMode : false;
      }
    }
    return this._cachedHasTargetRangeMode;
  }
  get targetRangeMode() {
    if (this._cachedTargetRangeMode === undefined) {
      if (this._value.hasTargetRangeMode) {
        this._cachedTargetRangeMode = this._value.targetRangeMode;
      } else {
        this._cachedTargetRangeMode = this._parent ? this._parent.targetRangeMode : this._value.targetRangeMode;
      }
    }
    return this._cachedTargetRangeMode;
  }
  get hasEffect() {
    if (this._cachedHasEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedHasEffect = true;
      } else {
        this._cachedHasEffect = this._parent ? this._parent.hasEffect : false;
      }
    }
    return this._cachedHasEffect;
  }
  get effect() {
    if (this._cachedEffect === undefined) {
      if (this._value.hasEffect) {
        this._cachedEffect = this._value.effect;
      } else {
        this._cachedEffect = this._parent ? this._parent.effect : this._value.effect;
      }
    }
    return this._cachedEffect;
  }
  get hasStats() {
    if (this._cachedHasStats === undefined) {
      if (this._value.hasStats) {
        this._cachedHasStats = true;
      } else {
        this._cachedHasStats = this._parent ? this._parent.hasStats : false;
      }
    }
    return this._cachedHasStats;
  }
  get stats() {
    if (!this._cachedStats) {
      if (this._value.hasStats) {
        this._cachedStats = new AbilityStats.WithParent(this._value.stats, this._parent && this._parent.hasStats ? this._parent.stats : null);
      } else {
        this._cachedStats = this._parent ? new AbilityStats.WithParent(AbilityStats.default, this._parent.stats) : AbilityStats.WithParent.default;
      }
    }
    return this._cachedStats;
  }
  get hasUseUnitCostDifference() {
    if (this._cachedHasUseUnitCostDifference === undefined) {
      if (this._value.hasUseUnitCostDifference) {
        this._cachedHasUseUnitCostDifference = true;
      } else {
        this._cachedHasUseUnitCostDifference = this._parent ? this._parent.hasUseUnitCostDifference : false;
      }
    }
    return this._cachedHasUseUnitCostDifference;
  }
  get useUnitCostDifference() {
    if (this._cachedUseUnitCostDifference === undefined) {
      if (this._value.hasUseUnitCostDifference) {
        this._cachedUseUnitCostDifference = this._value.useUnitCostDifference;
      } else {
        this._cachedUseUnitCostDifference = this._parent ? this._parent.useUnitCostDifference : this._value.useUnitCostDifference;
      }
    }
    return this._cachedUseUnitCostDifference;
  }
  get hasAddToUnitCost() {
    if (this._cachedHasAddToUnitCost === undefined) {
      if (this._value.hasAddToUnitCost) {
        this._cachedHasAddToUnitCost = true;
      } else {
        this._cachedHasAddToUnitCost = this._parent ? this._parent.hasAddToUnitCost : false;
      }
    }
    return this._cachedHasAddToUnitCost;
  }
  get addToUnitCost() {
    if (this._cachedAddToUnitCost === undefined) {
      if (this._value.hasAddToUnitCost) {
        this._cachedAddToUnitCost = this._value.addToUnitCost;
      } else {
        this._cachedAddToUnitCost = this._parent ? this._parent.addToUnitCost : this._value.addToUnitCost;
      }
    }
    return this._cachedAddToUnitCost;
  }
  get hasCost() {
    if (this._cachedHasCost === undefined) {
      if (this._value.hasCost) {
        this._cachedHasCost = true;
      } else {
        this._cachedHasCost = this._parent ? this._parent.hasCost : false;
      }
    }
    return this._cachedHasCost;
  }
  get cost() {
    if (!this._cachedCost) {
      if (this._value.hasCost) {
        this._cachedCost = new AbilityCost.WithParent(this._value.cost, this._parent && this._parent.hasCost ? this._parent.cost : null);
      } else {
        this._cachedCost = this._parent ? new AbilityCost.WithParent(AbilityCost.default, this._parent.cost) : AbilityCost.WithParent.default;
      }
    }
    return this._cachedCost;
  }
  get hasDeprecatedShow() {
    if (this._cachedHasDeprecatedShow === undefined) {
      if (this._value.hasDeprecatedShow) {
        this._cachedHasDeprecatedShow = true;
      } else {
        this._cachedHasDeprecatedShow = this._parent ? this._parent.hasDeprecatedShow : false;
      }
    }
    return this._cachedHasDeprecatedShow;
  }
  get show() {
    if (this._cachedDeprecatedShow === undefined) {
      if (this._value.hasDeprecatedShow) {
        this._cachedDeprecatedShow = this._value.show;
      } else {
        this._cachedDeprecatedShow = this._parent ? this._parent.show : this._value.show;
      }
    }
    return this._cachedDeprecatedShow;
  }
  get hasPriority() {
    if (this._cachedHasPriority === undefined) {
      if (this._value.hasPriority) {
        this._cachedHasPriority = true;
      } else {
        this._cachedHasPriority = this._parent ? this._parent.hasPriority : false;
      }
    }
    return this._cachedHasPriority;
  }
  get priority() {
    if (this._cachedPriority === undefined) {
      if (this._value.hasPriority) {
        this._cachedPriority = this._value.priority;
      } else {
        this._cachedPriority = this._parent ? this._parent.priority : this._value.priority;
      }
    }
    return this._cachedPriority;
  }
  get hasFamily() {
    if (this._cachedHasFamily === undefined) {
      if (this._value.hasFamily) {
        this._cachedHasFamily = true;
      } else {
        this._cachedHasFamily = this._parent ? this._parent.hasFamily : false;
      }
    }
    return this._cachedHasFamily;
  }
  get family() {
    if (this._cachedFamily === undefined) {
      if (this._value.hasFamily) {
        this._cachedFamily = this._value.family;
      } else {
        this._cachedFamily = this._parent ? this._parent.family : this._value.family;
      }
    }
    return this._cachedFamily;
  }
  get selfValidators() {
    return this._value.Validators;
  }
  get inherentValidators() {
    if (!this._inherentValidators) {
      this._inherentValidators = this._parent ? this._parent.Validators : [];
    }
    return this._inherentValidators;
  }
  get Validators() {
    if (!this._allValidators) {
      this._allValidators = this._parent ? this._parent.Validators.concat(this.selfValidators) : this.selfValidators;
    }
    return this._allValidators;
  }
  get hasLevel() {
    if (this._cachedHasLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedHasLevel = true;
      } else {
        this._cachedHasLevel = this._parent ? this._parent.hasLevel : false;
      }
    }
    return this._cachedHasLevel;
  }
  get level() {
    if (this._cachedLevel === undefined) {
      if (this._value.hasLevel) {
        this._cachedLevel = this._value.level;
      } else {
        this._cachedLevel = this._parent ? this._parent.level : this._value.level;
      }
    }
    return this._cachedLevel;
  }
  get hasCanCastWhileMoving() {
    if (this._cachedHasCanCastWhileMoving === undefined) {
      if (this._value.hasCanCastWhileMoving) {
        this._cachedHasCanCastWhileMoving = true;
      } else {
        this._cachedHasCanCastWhileMoving = this._parent ? this._parent.hasCanCastWhileMoving : false;
      }
    }
    return this._cachedHasCanCastWhileMoving;
  }
  get canCastWhileMoving() {
    if (this._cachedCanCastWhileMoving === undefined) {
      if (this._value.hasCanCastWhileMoving) {
        this._cachedCanCastWhileMoving = this._value.canCastWhileMoving;
      } else {
        this._cachedCanCastWhileMoving = this._parent ? this._parent.canCastWhileMoving : this._value.canCastWhileMoving;
      }
    }
    return this._cachedCanCastWhileMoving;
  }
  get hasIsRallyAbility() {
    if (this._cachedHasIsRallyAbility === undefined) {
      if (this._value.hasIsRallyAbility) {
        this._cachedHasIsRallyAbility = true;
      } else {
        this._cachedHasIsRallyAbility = this._parent ? this._parent.hasIsRallyAbility : false;
      }
    }
    return this._cachedHasIsRallyAbility;
  }
  get isRallyAbility() {
    if (this._cachedIsRallyAbility === undefined) {
      if (this._value.hasIsRallyAbility) {
        this._cachedIsRallyAbility = this._value.isRallyAbility;
      } else {
        this._cachedIsRallyAbility = this._parent ? this._parent.isRallyAbility : this._value.isRallyAbility;
      }
    }
    return this._cachedIsRallyAbility;
  }
  get hasDisabled() {
    if (this._cachedHasDisabled === undefined) {
      if (this._value.hasDisabled) {
        this._cachedHasDisabled = true;
      } else {
        this._cachedHasDisabled = this._parent ? this._parent.hasDisabled : false;
      }
    }
    return this._cachedHasDisabled;
  }
  get disabled() {
    if (this._cachedDisabled === undefined) {
      if (this._value.hasDisabled) {
        this._cachedDisabled = this._value.disabled;
      } else {
        this._cachedDisabled = this._parent ? this._parent.disabled : this._value.disabled;
      }
    }
    return this._cachedDisabled;
  }
  get hasHide() {
    if (this._cachedHasHide === undefined) {
      if (this._value.hasHide) {
        this._cachedHasHide = true;
      } else {
        this._cachedHasHide = this._parent ? this._parent.hasHide : false;
      }
    }
    return this._cachedHasHide;
  }
  get hide() {
    if (this._cachedHide === undefined) {
      if (this._value.hasHide) {
        this._cachedHide = this._value.hide;
      } else {
        this._cachedHide = this._parent ? this._parent.hide : this._value.hide;
      }
    }
    return this._cachedHide;
  }
  get hasDistanceCheckMode() {
    if (this._cachedHasDistanceCheckMode === undefined) {
      if (this._value.hasDistanceCheckMode) {
        this._cachedHasDistanceCheckMode = true;
      } else {
        this._cachedHasDistanceCheckMode = this._parent ? this._parent.hasDistanceCheckMode : false;
      }
    }
    return this._cachedHasDistanceCheckMode;
  }
  get distanceCheckMode() {
    if (this._cachedDistanceCheckMode === undefined) {
      if (this._value.hasDistanceCheckMode) {
        this._cachedDistanceCheckMode = this._value.distanceCheckMode;
      } else {
        this._cachedDistanceCheckMode = this._parent ? this._parent.distanceCheckMode : this._value.distanceCheckMode;
      }
    }
    return this._cachedDistanceCheckMode;
  }
  get hasDistanceExtendMode() {
    if (this._cachedHasDistanceExtendMode === undefined) {
      if (this._value.hasDistanceExtendMode) {
        this._cachedHasDistanceExtendMode = true;
      } else {
        this._cachedHasDistanceExtendMode = this._parent ? this._parent.hasDistanceExtendMode : false;
      }
    }
    return this._cachedHasDistanceExtendMode;
  }
  get distanceExtendMode() {
    if (this._cachedDistanceExtendMode === undefined) {
      if (this._value.hasDistanceExtendMode) {
        this._cachedDistanceExtendMode = this._value.distanceExtendMode;
      } else {
        this._cachedDistanceExtendMode = this._parent ? this._parent.distanceExtendMode : this._value.distanceExtendMode;
      }
    }
    return this._cachedDistanceExtendMode;
  }
  get hasTargetFilter() {
    if (this._cachedHasTargetFilter === undefined) {
      if (this._value.hasTargetFilter) {
        this._cachedHasTargetFilter = true;
      } else {
        this._cachedHasTargetFilter = this._parent ? this._parent.hasTargetFilter : false;
      }
    }
    return this._cachedHasTargetFilter;
  }
  get targetFilter() {
    if (!this._cachedTargetFilter) {
      if (this._value.hasTargetFilter) {
        this._cachedTargetFilter = new dcei_engine_effect_proto.SearchFilter.WithParent(this._value.targetFilter, this._parent && this._parent.hasTargetFilter ? this._parent.targetFilter : null);
      } else {
        this._cachedTargetFilter = this._parent ? new dcei_engine_effect_proto.SearchFilter.WithParent(dcei_engine_effect_proto.SearchFilter.default, this._parent.targetFilter) : dcei_engine_effect_proto.SearchFilter.WithParent.default;
      }
    }
    return this._cachedTargetFilter;
  }
  get hasHighlight() {
    if (this._cachedHasHighlight === undefined) {
      if (this._value.hasHighlight) {
        this._cachedHasHighlight = true;
      } else {
        this._cachedHasHighlight = this._parent ? this._parent.hasHighlight : false;
      }
    }
    return this._cachedHasHighlight;
  }
  get highlight() {
    if (this._cachedHighlight === undefined) {
      if (this._value.hasHighlight) {
        this._cachedHighlight = this._value.highlight;
      } else {
        this._cachedHighlight = this._parent ? this._parent.highlight : this._value.highlight;
      }
    }
    return this._cachedHighlight;
  }
  get selfAbilityTags() {
    return this._value.abilityTags;
  }
  get inherentAbilityTags() {
    if (!this._inherentAbilityTags) {
      this._inherentAbilityTags = this._parent ? this._parent.abilityTags : [];
    }
    return this._inherentAbilityTags;
  }
  get abilityTags() {
    if (!this._allAbilityTags) {
      this._allAbilityTags = this._parent ? this._parent.abilityTags.concat(this.selfAbilityTags) : this.selfAbilityTags;
    }
    return this._allAbilityTags;
  }
  get hasChargeIgnoreCooldown() {
    if (this._cachedHasChargeIgnoreCooldown === undefined) {
      if (this._value.hasChargeIgnoreCooldown) {
        this._cachedHasChargeIgnoreCooldown = true;
      } else {
        this._cachedHasChargeIgnoreCooldown = this._parent ? this._parent.hasChargeIgnoreCooldown : false;
      }
    }
    return this._cachedHasChargeIgnoreCooldown;
  }
  get chargeIgnoreCooldown() {
    if (this._cachedChargeIgnoreCooldown === undefined) {
      if (this._value.hasChargeIgnoreCooldown) {
        this._cachedChargeIgnoreCooldown = this._value.chargeIgnoreCooldown;
      } else {
        this._cachedChargeIgnoreCooldown = this._parent ? this._parent.chargeIgnoreCooldown : this._value.chargeIgnoreCooldown;
      }
    }
    return this._cachedChargeIgnoreCooldown;
  }
  get hasShowChargeCountUi() {
    if (this._cachedHasShowChargeCountUi === undefined) {
      if (this._value.hasShowChargeCountUi) {
        this._cachedHasShowChargeCountUi = true;
      } else {
        this._cachedHasShowChargeCountUi = this._parent ? this._parent.hasShowChargeCountUi : false;
      }
    }
    return this._cachedHasShowChargeCountUi;
  }
  get showChargeCountUi() {
    if (this._cachedShowChargeCountUi === undefined) {
      if (this._value.hasShowChargeCountUi) {
        this._cachedShowChargeCountUi = this._value.showChargeCountUi;
      } else {
        this._cachedShowChargeCountUi = this._parent ? this._parent.showChargeCountUi : this._value.showChargeCountUi;
      }
    }
    return this._cachedShowChargeCountUi;
  }
  get hasCriticalChance() {
    if (this._cachedHasCriticalChance === undefined) {
      if (this._value.hasCriticalChance) {
        this._cachedHasCriticalChance = true;
      } else {
        this._cachedHasCriticalChance = this._parent ? this._parent.hasCriticalChance : false;
      }
    }
    return this._cachedHasCriticalChance;
  }
  get criticalChance() {
    if (this._cachedCriticalChance === undefined) {
      if (this._value.hasCriticalChance) {
        this._cachedCriticalChance = this._value.criticalChance;
      } else {
        this._cachedCriticalChance = this._parent ? this._parent.criticalChance : this._value.criticalChance;
      }
    }
    return this._cachedCriticalChance;
  }
  get hasCriticalEffect() {
    if (this._cachedHasCriticalEffect === undefined) {
      if (this._value.hasCriticalEffect) {
        this._cachedHasCriticalEffect = true;
      } else {
        this._cachedHasCriticalEffect = this._parent ? this._parent.hasCriticalEffect : false;
      }
    }
    return this._cachedHasCriticalEffect;
  }
  get criticalEffect() {
    if (this._cachedCriticalEffect === undefined) {
      if (this._value.hasCriticalEffect) {
        this._cachedCriticalEffect = this._value.criticalEffect;
      } else {
        this._cachedCriticalEffect = this._parent ? this._parent.criticalEffect : this._value.criticalEffect;
      }
    }
    return this._cachedCriticalEffect;
  }
  get selfDependentUnits() {
    return this._value.dependentUnits;
  }
  get inherentDependentUnits() {
    if (!this._inherentDependentUnits) {
      this._inherentDependentUnits = this._parent ? this._parent.dependentUnits : [];
    }
    return this._inherentDependentUnits;
  }
  get dependentUnits() {
    if (!this._allDependentUnits) {
      this._allDependentUnits = this._parent ? this._parent.dependentUnits.concat(this.selfDependentUnits) : this.selfDependentUnits;
    }
    return this._allDependentUnits;
  }
  get selfDependentEffects() {
    return this._value.dependentEffects;
  }
  get inherentDependentEffects() {
    if (!this._inherentDependentEffects) {
      this._inherentDependentEffects = this._parent ? this._parent.dependentEffects : [];
    }
    return this._inherentDependentEffects;
  }
  get dependentEffects() {
    if (!this._allDependentEffects) {
      this._allDependentEffects = this._parent ? this._parent.dependentEffects.concat(this.selfDependentEffects) : this.selfDependentEffects;
    }
    return this._allDependentEffects;
  }
  get selfDependentBehaviors() {
    return this._value.dependentBehaviors;
  }
  get inherentDependentBehaviors() {
    if (!this._inherentDependentBehaviors) {
      this._inherentDependentBehaviors = this._parent ? this._parent.dependentBehaviors : [];
    }
    return this._inherentDependentBehaviors;
  }
  get dependentBehaviors() {
    if (!this._allDependentBehaviors) {
      this._allDependentBehaviors = this._parent ? this._parent.dependentBehaviors.concat(this.selfDependentBehaviors) : this.selfDependentBehaviors;
    }
    return this._allDependentBehaviors;
  }
  get hasDeprecatedUiButtonImage() {
    if (this._cachedHasDeprecatedUiButtonImage === undefined) {
      if (this._value.hasDeprecatedUiButtonImage) {
        this._cachedHasDeprecatedUiButtonImage = true;
      } else {
        this._cachedHasDeprecatedUiButtonImage = this._parent ? this._parent.hasDeprecatedUiButtonImage : false;
      }
    }
    return this._cachedHasDeprecatedUiButtonImage;
  }
  get uiButtonImage() {
    if (this._cachedDeprecatedUiButtonImage === undefined) {
      if (this._value.hasDeprecatedUiButtonImage) {
        this._cachedDeprecatedUiButtonImage = this._value.uiButtonImage;
      } else {
        this._cachedDeprecatedUiButtonImage = this._parent ? this._parent.uiButtonImage : this._value.uiButtonImage;
      }
    }
    return this._cachedDeprecatedUiButtonImage;
  }
  get hasDeprecatedUiButtonPosition() {
    if (this._cachedHasDeprecatedUiButtonPosition === undefined) {
      if (this._value.hasDeprecatedUiButtonPosition) {
        this._cachedHasDeprecatedUiButtonPosition = true;
      } else {
        this._cachedHasDeprecatedUiButtonPosition = this._parent ? this._parent.hasDeprecatedUiButtonPosition : false;
      }
    }
    return this._cachedHasDeprecatedUiButtonPosition;
  }
  get uiButtonPosition() {
    if (this._cachedDeprecatedUiButtonPosition === undefined) {
      if (this._value.hasDeprecatedUiButtonPosition) {
        this._cachedDeprecatedUiButtonPosition = this._value.uiButtonPosition;
      } else {
        this._cachedDeprecatedUiButtonPosition = this._parent ? this._parent.uiButtonPosition : this._value.uiButtonPosition;
      }
    }
    return this._cachedDeprecatedUiButtonPosition;
  }
  get hasCommandCardIndex() {
    if (this._cachedHasCommandCardIndex === undefined) {
      if (this._value.hasCommandCardIndex) {
        this._cachedHasCommandCardIndex = true;
      } else {
        this._cachedHasCommandCardIndex = this._parent ? this._parent.hasCommandCardIndex : false;
      }
    }
    return this._cachedHasCommandCardIndex;
  }
  get commandCardIndex() {
    if (this._cachedCommandCardIndex === undefined) {
      if (this._value.hasCommandCardIndex) {
        this._cachedCommandCardIndex = this._value.commandCardIndex;
      } else {
        this._cachedCommandCardIndex = this._parent ? this._parent.commandCardIndex : this._value.commandCardIndex;
      }
    }
    return this._cachedCommandCardIndex;
  }
  get hasCommandCardIcon() {
    if (this._cachedHasCommandCardIcon === undefined) {
      if (this._value.hasCommandCardIcon) {
        this._cachedHasCommandCardIcon = true;
      } else {
        this._cachedHasCommandCardIcon = this._parent ? this._parent.hasCommandCardIcon : false;
      }
    }
    return this._cachedHasCommandCardIcon;
  }
  get commandCardIcon() {
    if (this._cachedCommandCardIcon === undefined) {
      if (this._value.hasCommandCardIcon) {
        this._cachedCommandCardIcon = this._value.commandCardIcon;
      } else {
        this._cachedCommandCardIcon = this._parent ? this._parent.commandCardIcon : this._value.commandCardIcon;
      }
    }
    return this._cachedCommandCardIcon;
  }
  get hasCommandCardConfirmIcon() {
    if (this._cachedHasCommandCardConfirmIcon === undefined) {
      if (this._value.hasCommandCardConfirmIcon) {
        this._cachedHasCommandCardConfirmIcon = true;
      } else {
        this._cachedHasCommandCardConfirmIcon = this._parent ? this._parent.hasCommandCardConfirmIcon : false;
      }
    }
    return this._cachedHasCommandCardConfirmIcon;
  }
  get commandCardConfirmIcon() {
    if (this._cachedCommandCardConfirmIcon === undefined) {
      if (this._value.hasCommandCardConfirmIcon) {
        this._cachedCommandCardConfirmIcon = this._value.commandCardConfirmIcon;
      } else {
        this._cachedCommandCardConfirmIcon = this._parent ? this._parent.commandCardConfirmIcon : this._value.commandCardConfirmIcon;
      }
    }
    return this._cachedCommandCardConfirmIcon;
  }
  get hasCommandCardDisplayText() {
    if (this._cachedHasCommandCardDisplayText === undefined) {
      if (this._value.hasCommandCardDisplayText) {
        this._cachedHasCommandCardDisplayText = true;
      } else {
        this._cachedHasCommandCardDisplayText = this._parent ? this._parent.hasCommandCardDisplayText : false;
      }
    }
    return this._cachedHasCommandCardDisplayText;
  }
  get commandCardDisplayText() {
    if (this._cachedCommandCardDisplayText === undefined) {
      if (this._value.hasCommandCardDisplayText) {
        this._cachedCommandCardDisplayText = this._value.commandCardDisplayText;
      } else {
        this._cachedCommandCardDisplayText = this._parent ? this._parent.commandCardDisplayText : this._value.commandCardDisplayText;
      }
    }
    return this._cachedCommandCardDisplayText;
  }
  get hasCommandCardEnhancementIcon() {
    if (this._cachedHasCommandCardEnhancementIcon === undefined) {
      if (this._value.hasCommandCardEnhancementIcon) {
        this._cachedHasCommandCardEnhancementIcon = true;
      } else {
        this._cachedHasCommandCardEnhancementIcon = this._parent ? this._parent.hasCommandCardEnhancementIcon : false;
      }
    }
    return this._cachedHasCommandCardEnhancementIcon;
  }
  get commandCardEnhancementIcon() {
    if (this._cachedCommandCardEnhancementIcon === undefined) {
      if (this._value.hasCommandCardEnhancementIcon) {
        this._cachedCommandCardEnhancementIcon = this._value.commandCardEnhancementIcon;
      } else {
        this._cachedCommandCardEnhancementIcon = this._parent ? this._parent.commandCardEnhancementIcon : this._value.commandCardEnhancementIcon;
      }
    }
    return this._cachedCommandCardEnhancementIcon;
  }
  get hasCommandCardOrnamentIcon() {
    if (this._cachedHasCommandCardOrnamentIcon === undefined) {
      if (this._value.hasCommandCardOrnamentIcon) {
        this._cachedHasCommandCardOrnamentIcon = true;
      } else {
        this._cachedHasCommandCardOrnamentIcon = this._parent ? this._parent.hasCommandCardOrnamentIcon : false;
      }
    }
    return this._cachedHasCommandCardOrnamentIcon;
  }
  get commandCardOrnamentIcon() {
    if (this._cachedCommandCardOrnamentIcon === undefined) {
      if (this._value.hasCommandCardOrnamentIcon) {
        this._cachedCommandCardOrnamentIcon = this._value.commandCardOrnamentIcon;
      } else {
        this._cachedCommandCardOrnamentIcon = this._parent ? this._parent.commandCardOrnamentIcon : this._value.commandCardOrnamentIcon;
      }
    }
    return this._cachedCommandCardOrnamentIcon;
  }
  get hasPreserveMenu() {
    if (this._cachedHasPreserveMenu === undefined) {
      if (this._value.hasPreserveMenu) {
        this._cachedHasPreserveMenu = true;
      } else {
        this._cachedHasPreserveMenu = this._parent ? this._parent.hasPreserveMenu : false;
      }
    }
    return this._cachedHasPreserveMenu;
  }
  get preserveMenu() {
    if (this._cachedPreserveMenu === undefined) {
      if (this._value.hasPreserveMenu) {
        this._cachedPreserveMenu = this._value.preserveMenu;
      } else {
        this._cachedPreserveMenu = this._parent ? this._parent.preserveMenu : this._value.preserveMenu;
      }
    }
    return this._cachedPreserveMenu;
  }
  get hasDescription() {
    if (this._cachedHasDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedHasDescription = true;
      } else {
        this._cachedHasDescription = this._parent ? this._parent.hasDescription : false;
      }
    }
    return this._cachedHasDescription;
  }
  get description() {
    if (this._cachedDescription === undefined) {
      if (this._value.hasDescription) {
        this._cachedDescription = this._value.description;
      } else {
        this._cachedDescription = this._parent ? this._parent.description : this._value.description;
      }
    }
    return this._cachedDescription;
  }
  get hasTitle() {
    if (this._cachedHasTitle === undefined) {
      if (this._value.hasTitle) {
        this._cachedHasTitle = true;
      } else {
        this._cachedHasTitle = this._parent ? this._parent.hasTitle : false;
      }
    }
    return this._cachedHasTitle;
  }
  get title() {
    if (this._cachedTitle === undefined) {
      if (this._value.hasTitle) {
        this._cachedTitle = this._value.title;
      } else {
        this._cachedTitle = this._parent ? this._parent.title : this._value.title;
      }
    }
    return this._cachedTitle;
  }
  get hasAffinityIndex() {
    if (this._cachedHasAffinityIndex === undefined) {
      if (this._value.hasAffinityIndex) {
        this._cachedHasAffinityIndex = true;
      } else {
        this._cachedHasAffinityIndex = this._parent ? this._parent.hasAffinityIndex : false;
      }
    }
    return this._cachedHasAffinityIndex;
  }
  get affinityIndex() {
    if (this._cachedAffinityIndex === undefined) {
      if (this._value.hasAffinityIndex) {
        this._cachedAffinityIndex = this._value.affinityIndex;
      } else {
        this._cachedAffinityIndex = this._parent ? this._parent.affinityIndex : this._value.affinityIndex;
      }
    }
    return this._cachedAffinityIndex;
  }
  get hasCardName() {
    if (this._cachedHasCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedHasCardName = true;
      } else {
        this._cachedHasCardName = this._parent ? this._parent.hasCardName : false;
      }
    }
    return this._cachedHasCardName;
  }
  get cardName() {
    if (this._cachedCardName === undefined) {
      if (this._value.hasCardName) {
        this._cachedCardName = this._value.cardName;
      } else {
        this._cachedCardName = this._parent ? this._parent.cardName : this._value.cardName;
      }
    }
    return this._cachedCardName;
  }
  get hasTargetingValidCursorActor() {
    if (this._cachedHasTargetingValidCursorActor === undefined) {
      if (this._value.hasTargetingValidCursorActor) {
        this._cachedHasTargetingValidCursorActor = true;
      } else {
        this._cachedHasTargetingValidCursorActor = this._parent ? this._parent.hasTargetingValidCursorActor : false;
      }
    }
    return this._cachedHasTargetingValidCursorActor;
  }
  get targetingValidCursorActor() {
    if (this._cachedTargetingValidCursorActor === undefined) {
      if (this._value.hasTargetingValidCursorActor) {
        this._cachedTargetingValidCursorActor = this._value.targetingValidCursorActor;
      } else {
        this._cachedTargetingValidCursorActor = this._parent ? this._parent.targetingValidCursorActor : this._value.targetingValidCursorActor;
      }
    }
    return this._cachedTargetingValidCursorActor;
  }
  get hasTargetingInvalidCursorActor() {
    if (this._cachedHasTargetingInvalidCursorActor === undefined) {
      if (this._value.hasTargetingInvalidCursorActor) {
        this._cachedHasTargetingInvalidCursorActor = true;
      } else {
        this._cachedHasTargetingInvalidCursorActor = this._parent ? this._parent.hasTargetingInvalidCursorActor : false;
      }
    }
    return this._cachedHasTargetingInvalidCursorActor;
  }
  get targetingInvalidCursorActor() {
    if (this._cachedTargetingInvalidCursorActor === undefined) {
      if (this._value.hasTargetingInvalidCursorActor) {
        this._cachedTargetingInvalidCursorActor = this._value.targetingInvalidCursorActor;
      } else {
        this._cachedTargetingInvalidCursorActor = this._parent ? this._parent.targetingInvalidCursorActor : this._value.targetingInvalidCursorActor;
      }
    }
    return this._cachedTargetingInvalidCursorActor;
  }
  update(current, parent) {
    const result = new Ability_WithParent(current, parent);
    if (this._cachedStats && this._value.hasStats && current.hasStats) {
      if (this._value.stats === current.stats && this._parent === parent) {
        result._cachedStats = this._cachedStats;
      } else {
        result._cachedStats = this._cachedStats.update(current.stats, parent && parent.hasStats ? parent.stats : null);
      }
    }
    if (this._cachedCost && this._value.hasCost && current.hasCost) {
      if (this._value.cost === current.cost && this._parent === parent) {
        result._cachedCost = this._cachedCost;
      } else {
        result._cachedCost = this._cachedCost.update(current.cost, parent && parent.hasCost ? parent.cost : null);
      }
    }
    if (this._cachedTargetFilter && this._value.hasTargetFilter && current.hasTargetFilter) {
      if (this._value.targetFilter === current.targetFilter && this._parent === parent) {
        result._cachedTargetFilter = this._cachedTargetFilter;
      } else {
        result._cachedTargetFilter = this._cachedTargetFilter.update(current.targetFilter, parent && parent.hasTargetFilter ? parent.targetFilter : null);
      }
    }
    return result;
  }
}
Ability_WithParent.default = new Ability_WithParent(Ability.default, null);
Ability.WithParent = Ability_WithParent;
class Ability_Descriptor {
  get prefix() {
    if (!this._prefix) {
      this._prefix = {
        name: "prefix",
        Name: "Prefix",
        number: 1000,
        protoType: 9,
        protoName: "prefix",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prefix;
  }
  get template() {
    if (!this._template) {
      this._template = {
        name: "template",
        Name: "Template",
        number: 2000,
        protoType: 8,
        protoName: "template",
        type: JsonToBoolean,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._template;
  }
  get comment() {
    if (!this._comment) {
      this._comment = {
        name: "comment",
        Name: "Comment",
        number: 3000,
        protoType: 9,
        protoName: "comment",
        type: JsonToString,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._comment;
  }
  get parent() {
    if (!this._parent) {
      this._parent = {
        name: "parent",
        Name: "Parent",
        number: 1,
        protoType: 9,
        protoName: "parent",
        type: JsonToString,
        options: {
          valueDropdown: "SupportedAbilityNamesWithNullWithTemplate",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._parent;
  }
  get abilityType() {
    if (!this._abilityType) {
      this._abilityType = {
        name: "abilityType",
        Name: "AbilityType",
        number: 2,
        protoType: 14,
        protoName: "ability_type",
        type: Ability_AbilityType,
        options: {
          default: "INSTANT",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityType;
  }
  get castType() {
    if (!this._castType) {
      this._castType = {
        name: "castType",
        Name: "CastType",
        number: 3,
        protoType: 14,
        protoName: "cast_type",
        type: Ability_CastType,
        options: {
          default: "MANUAL",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._castType;
  }
  get targetRangeMode() {
    if (!this._targetRangeMode) {
      this._targetRangeMode = {
        name: "targetRangeMode",
        Name: "TargetRangeMode",
        number: 4,
        protoType: 14,
        protoName: "target_range_mode",
        type: Ability_TargetRangeModes,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetRangeMode;
  }
  get effect() {
    if (!this._effect) {
      this._effect = {
        name: "effect",
        Name: "Effect",
        number: 5,
        protoType: 9,
        protoName: "effect",
        type: JsonToString,
        options: {
          comments: "The effect used by the ability when it is cast.",
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._effect;
  }
  get stats() {
    if (!this._stats) {
      this._stats = {
        name: "stats",
        Name: "Stats",
        number: 6,
        protoType: 11,
        protoName: "stats",
        type: AbilityStats,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._stats;
  }
  get useUnitCostDifference() {
    if (!this._useUnitCostDifference) {
      this._useUnitCostDifference = {
        name: "useUnitCostDifference",
        Name: "UseUnitCostDifference",
        number: 7,
        protoType: 8,
        protoName: "use_unit_cost_difference",
        type: JsonToBoolean,
        options: {
          comments: "If the ability contains a morph effect, uses the difference in gold cost between the two units as the ability\'s gold cost.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useUnitCostDifference;
  }
  get addToUnitCost() {
    if (!this._addToUnitCost) {
      this._addToUnitCost = {
        name: "addToUnitCost",
        Name: "AddToUnitCost",
        number: 8,
        protoType: 8,
        protoName: "add_to_unit_cost",
        type: JsonToBoolean,
        options: {
          comments: "When checked, the cost of unit will be increased by the gold cost of the ability when it is cast.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._addToUnitCost;
  }
  get cost() {
    if (!this._cost) {
      this._cost = {
        name: "cost",
        Name: "Cost",
        number: 9,
        protoType: 11,
        protoName: "cost",
        type: AbilityCost,
        options: {
          comments: "What resources the unit uses when it casts the ability. If the unit is unable to meet any of the costs, it is unable to cast the ability.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cost;
  }
  get show() {
    if (!this._show) {
      this._show = {
        name: "show",
        Name: "DeprecatedShow",
        number: 1009,
        protoType: 8,
        protoName: "deprecated_show",
        type: JsonToBoolean,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._show;
  }
  get priority() {
    if (!this._priority) {
      this._priority = {
        name: "priority",
        Name: "Priority",
        number: 10,
        protoType: 5,
        protoName: "priority",
        type: JsonToInt32,
        options: {
          comments: "Abilities with higher priority can interrupt the casting of abilities with lower priority.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._priority;
  }
  get family() {
    if (!this._family) {
      this._family = {
        name: "family",
        Name: "Family",
        number: 11,
        protoType: 9,
        protoName: "family",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._family;
  }
  get Validators() {
    if (!this._Validators) {
      this._Validators = {
        name: "Validators",
        Name: "Validators",
        number: 12,
        protoType: 9,
        protoName: "Validators",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Each validator must succeed in order for the ability to be able to be cast.",
          valueDropdown: "SupportedValidatorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._Validators;
  }
  get level() {
    if (!this._level) {
      this._level = {
        name: "level",
        Name: "Level",
        number: 13,
        protoType: 5,
        protoName: "level",
        type: JsonToInt32,
        options: {
          comments: "Ability level reference that can be referenced in validator expressions.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._level;
  }
  get canCastWhileMoving() {
    if (!this._canCastWhileMoving) {
      this._canCastWhileMoving = {
        name: "canCastWhileMoving",
        Name: "CanCastWhileMoving",
        number: 14,
        protoType: 8,
        protoName: "can_cast_while_moving",
        type: JsonToBoolean,
        options: {
          comments: "If this is checked, using this ability will not stop movement.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._canCastWhileMoving;
  }
  get isRallyAbility() {
    if (!this._isRallyAbility) {
      this._isRallyAbility = {
        name: "isRallyAbility",
        Name: "IsRallyAbility",
        number: 15,
        protoType: 8,
        protoName: "is_rally_ability",
        type: JsonToBoolean,
        options: {
          comments: "Used for additional rally ability functionality in Wild Sky.",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._isRallyAbility;
  }
  get disabled() {
    if (!this._disabled) {
      this._disabled = {
        name: "disabled",
        Name: "Disabled",
        number: 21,
        protoType: 8,
        protoName: "disabled",
        type: JsonToBoolean,
        options: {
          comments: "When checked, the ability is disabled by default. Requires behaviors or other means to be enabled.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._disabled;
  }
  get hide() {
    if (!this._hide) {
      this._hide = {
        name: "hide",
        Name: "Hide",
        number: 22,
        protoType: 8,
        protoName: "hide",
        type: JsonToBoolean,
        options: {
          comments: "When checked, the ability is hidden from the command card by default. Requires behaviors or other means to be visible.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._hide;
  }
  get distanceCheckMode() {
    if (!this._distanceCheckMode) {
      this._distanceCheckMode = {
        name: "distanceCheckMode",
        Name: "DistanceCheckMode",
        number: 23,
        protoType: 14,
        protoName: "distance_check_mode",
        type: dcei_engine_effect_proto.DistanceCheckModes,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._distanceCheckMode;
  }
  get distanceExtendMode() {
    if (!this._distanceExtendMode) {
      this._distanceExtendMode = {
        name: "distanceExtendMode",
        Name: "DistanceExtendMode",
        number: 24,
        protoType: 14,
        protoName: "distance_extend_mode",
        type: dcei_engine_effect_proto.DistanceExtendModes,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._distanceExtendMode;
  }
  get targetFilter() {
    if (!this._targetFilter) {
      this._targetFilter = {
        name: "targetFilter",
        Name: "TargetFilter",
        number: 25,
        protoType: 11,
        protoName: "target_filter",
        type: dcei_engine_effect_proto.SearchFilter,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetFilter;
  }
  get highlight() {
    if (!this._highlight) {
      this._highlight = {
        name: "highlight",
        Name: "Highlight",
        number: 26,
        protoType: 8,
        protoName: "highlight",
        type: JsonToBoolean,
        options: {
          comments: "If checked, the ability will always be highlighted on the unit\'s command card and a behavior or some other means will be needed to stop it.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._highlight;
  }
  get abilityTags() {
    if (!this._abilityTags) {
      this._abilityTags = {
        name: "abilityTags",
        Name: "AbilityTags",
        number: 27,
        protoType: 9,
        protoName: "ability_tags",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Used in conjunction with Issue Ability effect to cast abilities with specific tags.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._abilityTags;
  }
  get chargeIgnoreCooldown() {
    if (!this._chargeIgnoreCooldown) {
      this._chargeIgnoreCooldown = {
        name: "chargeIgnoreCooldown",
        Name: "ChargeIgnoreCooldown",
        number: 28,
        protoType: 8,
        protoName: "charge_ignore_cooldown",
        type: JsonToBoolean,
        options: {
          comments: "If checked, the ability charges will not recover each cooldown. Instead the ability charges must be changed some other way.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._chargeIgnoreCooldown;
  }
  get showChargeCountUi() {
    if (!this._showChargeCountUi) {
      this._showChargeCountUi = {
        name: "showChargeCountUi",
        Name: "ShowChargeCountUi",
        number: 29,
        protoType: 8,
        protoName: "show_charge_count_ui",
        type: JsonToBoolean,
        options: {
          comments: "Whether the charges of the ability are displayed in the in-game UI or not.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._showChargeCountUi;
  }
  get criticalChance() {
    if (!this._criticalChance) {
      this._criticalChance = {
        name: "criticalChance",
        Name: "CriticalChance",
        number: 30,
        protoType: 1,
        protoName: "critical_chance",
        type: JsonToDouble,
        options: {
          comments: "The chance that the ability usage is considered a critical. The value is a fraction, so 0 is 0% chance and 1 is 100% chance of critical hit.",
          propertyRange: "0,1",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._criticalChance;
  }
  get criticalEffect() {
    if (!this._criticalEffect) {
      this._criticalEffect = {
        name: "criticalEffect",
        Name: "CriticalEffect",
        number: 31,
        protoType: 9,
        protoName: "critical_effect",
        type: JsonToString,
        options: {
          comments: "The effect that is executed instead of the effect when the ability is a critical.",
          valueDropdown: "SupportedEffectListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._criticalEffect;
  }
  get dependentUnits() {
    if (!this._dependentUnits) {
      this._dependentUnits = {
        name: "dependentUnits",
        Name: "DependentUnits",
        number: 41,
        protoType: 9,
        protoName: "dependent_units",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Dependent units will be loaded when the ability is loaded.",
          valueDropdown: "SupportedBaseUnitNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependentUnits;
  }
  get dependentEffects() {
    if (!this._dependentEffects) {
      this._dependentEffects = {
        name: "dependentEffects",
        Name: "DependentEffects",
        number: 42,
        protoType: 9,
        protoName: "dependent_effects",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Dependent effects will be loaded when this unit is loaded.",
          valueDropdown: "SupportedEffectListNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependentEffects;
  }
  get dependentBehaviors() {
    if (!this._dependentBehaviors) {
      this._dependentBehaviors = {
        name: "dependentBehaviors",
        Name: "DependentBehaviors",
        number: 43,
        protoType: 9,
        protoName: "dependent_behaviors",
        type: JsonToString,
        isRepeated: true,
        options: {
          comments: "Dependent behaviors will be loaded when this unit is loaded.",
          valueDropdown: "SupportedBehaviorNames",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._dependentBehaviors;
  }
  get uiButtonImage() {
    if (!this._uiButtonImage) {
      this._uiButtonImage = {
        name: "uiButtonImage",
        Name: "DeprecatedUiButtonImage",
        number: 101,
        protoType: 14,
        protoName: "deprecated_ui_button_image",
        type: Ability_UiButtonImageType,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._uiButtonImage;
  }
  get uiButtonPosition() {
    if (!this._uiButtonPosition) {
      this._uiButtonPosition = {
        name: "uiButtonPosition",
        Name: "DeprecatedUiButtonPosition",
        number: 102,
        protoType: 14,
        protoName: "deprecated_ui_button_position",
        type: Ability_UiButtonPositionType,
        options: {
          hideInInspector: true,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._uiButtonPosition;
  }
  get commandCardIndex() {
    if (!this._commandCardIndex) {
      this._commandCardIndex = {
        name: "commandCardIndex",
        Name: "CommandCardIndex",
        number: 201,
        protoType: 5,
        protoName: "command_card_index",
        type: JsonToInt32,
        options: {
          comments: "What slot of the In-Game UI Command Card the ability occupies.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._commandCardIndex;
  }
  get commandCardIcon() {
    if (!this._commandCardIcon) {
      this._commandCardIcon = {
        name: "commandCardIcon",
        Name: "CommandCardIcon",
        number: 202,
        protoType: 9,
        protoName: "command_card_icon",
        type: JsonToString,
        options: {
          comments: "The icon of the ability.",
          valueDropdown: "SupportedInGameIcons",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._commandCardIcon;
  }
  get commandCardConfirmIcon() {
    if (!this._commandCardConfirmIcon) {
      this._commandCardConfirmIcon = {
        name: "commandCardConfirmIcon",
        Name: "CommandCardConfirmIcon",
        number: 207,
        protoType: 9,
        protoName: "command_card_confirm_icon",
        type: JsonToString,
        options: {
          comments: "If the ability needs to be confirmed (i.e., tap a second time to use), the icon to display after the first tap.",
          valueDropdown: "SupportedInGameIcons",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._commandCardConfirmIcon;
  }
  get commandCardDisplayText() {
    if (!this._commandCardDisplayText) {
      this._commandCardDisplayText = {
        name: "commandCardDisplayText",
        Name: "CommandCardDisplayText",
        number: 203,
        protoType: 9,
        protoName: "command_card_display_text",
        type: JsonToString,
        options: {
          comments: "The text that the ability button displays when it is opened.",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._commandCardDisplayText;
  }
  get commandCardEnhancementIcon() {
    if (!this._commandCardEnhancementIcon) {
      this._commandCardEnhancementIcon = {
        name: "commandCardEnhancementIcon",
        Name: "CommandCardEnhancementIcon",
        number: 205,
        protoType: 9,
        protoName: "command_card_enhancement_icon",
        type: JsonToString,
        options: {
          comments: "The icon for the ability when it is enhanced.",
          valueDropdown: "SupportedInGameIcons",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._commandCardEnhancementIcon;
  }
  get commandCardOrnamentIcon() {
    if (!this._commandCardOrnamentIcon) {
      this._commandCardOrnamentIcon = {
        name: "commandCardOrnamentIcon",
        Name: "CommandCardOrnamentIcon",
        number: 206,
        protoType: 9,
        protoName: "command_card_ornament_icon",
        type: JsonToString,
        options: {
          comments: "The icon for the ability when it has an ornament.",
          valueDropdown: "SupportedInGameIcons",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._commandCardOrnamentIcon;
  }
  get preserveMenu() {
    if (!this._preserveMenu) {
      this._preserveMenu = {
        name: "preserveMenu",
        Name: "PreserveMenu",
        number: 204,
        protoType: 8,
        protoName: "preserve_menu",
        type: JsonToBoolean,
        options: {
          comments: "When the ability is used through the tower menu, the menu stays open.",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._preserveMenu;
  }
  get description() {
    if (!this._description) {
      this._description = {
        name: "description",
        Name: "Description",
        number: 301,
        protoType: 9,
        protoName: "description",
        type: JsonToString,
        options: {
          comments: "Used by wild sky, can be used for the description of an ability.",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._description;
  }
  get title() {
    if (!this._title) {
      this._title = {
        name: "title",
        Name: "Title",
        number: 302,
        protoType: 9,
        protoName: "title",
        type: JsonToString,
        options: {
          comments: "Used by wild sky, can be used to form a title for the ability.",
          view: "wildsky",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._title;
  }
  get affinityIndex() {
    if (!this._affinityIndex) {
      this._affinityIndex = {
        name: "affinityIndex",
        Name: "AffinityIndex",
        number: 401,
        protoType: 5,
        protoName: "affinity_index",
        type: JsonToInt32,
        options: {
          comments: "The affinity of this ability. Only set this field if: 1. this is a ship ability. 2. and this ability is used as a built-in ability (i.e., not added through a loadout spell card but available in the level automatically). The mapping: 1 => normal 2 => fire 3 => ice 4 => nature 5 => light 6 => dark.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._affinityIndex;
  }
  get cardName() {
    if (!this._cardName) {
      this._cardName = {
        name: "cardName",
        Name: "CardName",
        number: 402,
        protoType: 9,
        protoName: "card_name",
        type: JsonToString,
        options: {
          comments: "Used to associate the ability with a card name for damage stats tracking.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._cardName;
  }
  get targetingValidCursorActor() {
    if (!this._targetingValidCursorActor) {
      this._targetingValidCursorActor = {
        name: "targetingValidCursorActor",
        Name: "TargetingValidCursorActor",
        number: 501,
        protoType: 9,
        protoName: "targeting_valid_cursor_actor",
        type: JsonToString,
        options: {
          comments: "The cursor actor used for the ability\'s target mode when the target is valid.",
          valueDropdown: "SupportedActorListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetingValidCursorActor;
  }
  get targetingInvalidCursorActor() {
    if (!this._targetingInvalidCursorActor) {
      this._targetingInvalidCursorActor = {
        name: "targetingInvalidCursorActor",
        Name: "TargetingInvalidCursorActor",
        number: 502,
        protoType: 9,
        protoName: "targeting_invalid_cursor_actor",
        type: JsonToString,
        options: {
          comments: "The cursor actor used for the ability\'s target mode when the target is invalid.",
          valueDropdown: "SupportedActorListNamesWithNull",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._targetingInvalidCursorActor;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.prefix,
        this.template,
        this.comment,
        this.parent,
        this.abilityType,
        this.castType,
        this.targetRangeMode,
        this.effect,
        this.stats,
        this.useUnitCostDifference,
        this.addToUnitCost,
        this.cost,
        this.show,
        this.priority,
        this.family,
        this.Validators,
        this.level,
        this.canCastWhileMoving,
        this.isRallyAbility,
        this.disabled,
        this.hide,
        this.distanceCheckMode,
        this.distanceExtendMode,
        this.targetFilter,
        this.highlight,
        this.abilityTags,
        this.chargeIgnoreCooldown,
        this.showChargeCountUi,
        this.criticalChance,
        this.criticalEffect,
        this.dependentUnits,
        this.dependentEffects,
        this.dependentBehaviors,
        this.uiButtonImage,
        this.uiButtonPosition,
        this.commandCardIndex,
        this.commandCardIcon,
        this.commandCardConfirmIcon,
        this.commandCardDisplayText,
        this.commandCardEnhancementIcon,
        this.commandCardOrnamentIcon,
        this.preserveMenu,
        this.description,
        this.title,
        this.affinityIndex,
        this.cardName,
        this.targetingValidCursorActor,
        this.targetingInvalidCursorActor,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPrefix",
        Name: "DummyOneofForPrefix",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTemplate",
        Name: "DummyOneofForTemplate",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForComment",
        Name: "DummyOneofForComment",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForParent",
        Name: "DummyOneofForParent",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAbilityType",
        Name: "DummyOneofForAbilityType",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCastType",
        Name: "DummyOneofForCastType",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetRangeMode",
        Name: "DummyOneofForTargetRangeMode",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForEffect",
        Name: "DummyOneofForEffect",
        fields: [
          this.fields[7],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForStats",
        Name: "DummyOneofForStats",
        fields: [
          this.fields[8],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseUnitCostDifference",
        Name: "DummyOneofForUseUnitCostDifference",
        fields: [
          this.fields[9],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAddToUnitCost",
        Name: "DummyOneofForAddToUnitCost",
        fields: [
          this.fields[10],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCost",
        Name: "DummyOneofForCost",
        fields: [
          this.fields[11],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedShow",
        Name: "DummyOneofForDeprecatedShow",
        fields: [
          this.fields[12],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPriority",
        Name: "DummyOneofForPriority",
        fields: [
          this.fields[13],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFamily",
        Name: "DummyOneofForFamily",
        fields: [
          this.fields[14],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForLevel",
        Name: "DummyOneofForLevel",
        fields: [
          this.fields[16],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCanCastWhileMoving",
        Name: "DummyOneofForCanCastWhileMoving",
        fields: [
          this.fields[17],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForIsRallyAbility",
        Name: "DummyOneofForIsRallyAbility",
        fields: [
          this.fields[18],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDisabled",
        Name: "DummyOneofForDisabled",
        fields: [
          this.fields[19],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHide",
        Name: "DummyOneofForHide",
        fields: [
          this.fields[20],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDistanceCheckMode",
        Name: "DummyOneofForDistanceCheckMode",
        fields: [
          this.fields[21],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDistanceExtendMode",
        Name: "DummyOneofForDistanceExtendMode",
        fields: [
          this.fields[22],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetFilter",
        Name: "DummyOneofForTargetFilter",
        fields: [
          this.fields[23],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForHighlight",
        Name: "DummyOneofForHighlight",
        fields: [
          this.fields[24],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForChargeIgnoreCooldown",
        Name: "DummyOneofForChargeIgnoreCooldown",
        fields: [
          this.fields[26],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForShowChargeCountUi",
        Name: "DummyOneofForShowChargeCountUi",
        fields: [
          this.fields[27],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCriticalChance",
        Name: "DummyOneofForCriticalChance",
        fields: [
          this.fields[28],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCriticalEffect",
        Name: "DummyOneofForCriticalEffect",
        fields: [
          this.fields[29],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedUiButtonImage",
        Name: "DummyOneofForDeprecatedUiButtonImage",
        fields: [
          this.fields[33],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDeprecatedUiButtonPosition",
        Name: "DummyOneofForDeprecatedUiButtonPosition",
        fields: [
          this.fields[34],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCommandCardIndex",
        Name: "DummyOneofForCommandCardIndex",
        fields: [
          this.fields[35],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCommandCardIcon",
        Name: "DummyOneofForCommandCardIcon",
        fields: [
          this.fields[36],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCommandCardConfirmIcon",
        Name: "DummyOneofForCommandCardConfirmIcon",
        fields: [
          this.fields[37],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCommandCardDisplayText",
        Name: "DummyOneofForCommandCardDisplayText",
        fields: [
          this.fields[38],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCommandCardEnhancementIcon",
        Name: "DummyOneofForCommandCardEnhancementIcon",
        fields: [
          this.fields[39],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCommandCardOrnamentIcon",
        Name: "DummyOneofForCommandCardOrnamentIcon",
        fields: [
          this.fields[40],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForPreserveMenu",
        Name: "DummyOneofForPreserveMenu",
        fields: [
          this.fields[41],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForDescription",
        Name: "DummyOneofForDescription",
        fields: [
          this.fields[42],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTitle",
        Name: "DummyOneofForTitle",
        fields: [
          this.fields[43],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForAffinityIndex",
        Name: "DummyOneofForAffinityIndex",
        fields: [
          this.fields[44],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCardName",
        Name: "DummyOneofForCardName",
        fields: [
          this.fields[45],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetingValidCursorActor",
        Name: "DummyOneofForTargetingValidCursorActor",
        fields: [
          this.fields[46],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForTargetingInvalidCursorActor",
        Name: "DummyOneofForTargetingInvalidCursorActor",
        fields: [
          this.fields[47],
        ],
      });
    }
    return this._oneofs;
  }
}
Ability.descriptor = new Ability_Descriptor();
export class AbilityStats {
  get descriptor() {
    return AbilityStats.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasPrepTime = false;
    this._prepTime = null;
    this._hasFinishTime = false;
    this._finishTime = null;
    this._hasCooldown = false;
    this._period = null;
    this._hasUseInitialCooldown = false;
    this._useInitialCooldown = null;
    this._hasUseCooldownOnEnable = false;
    this._useCooldownOnEnable = null;
    this._hasRange = false;
    this._range = null;
    this._hasMaxCharge = false;
    this._maxCharge = null;
    this._hasArc = false;
    this._arc = null;
  }
  isEmpty() {
    if (this._hasPrepTime) return false;
    if (this._hasFinishTime) return false;
    if (this._hasCooldown) return false;
    if (this._hasUseInitialCooldown) return false;
    if (this._hasUseCooldownOnEnable) return false;
    if (this._hasRange) return false;
    if (this._hasMaxCharge) return false;
    if (this._hasArc) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AbilityStats) {
      return value;
    }
    return AbilityStats.fromJson(value);
  }
  static fromJson(json) {
    const result = new AbilityStats();
    if (json.prepTime != null) {
      result._hasPrepTime = true;
      result._prepTime = JsonToDouble.fromJson(json.prepTime);
    }
    if (json.finishTime != null) {
      result._hasFinishTime = true;
      result._finishTime = JsonToDouble.fromJson(json.finishTime);
    }
    if (json.period != null) {
      result._hasCooldown = true;
      result._period = JsonToDouble.fromJson(json.period);
    }
    if (json.useInitialCooldown != null) {
      result._hasUseInitialCooldown = true;
      result._useInitialCooldown = JsonToBoolean.fromJson(json.useInitialCooldown);
    }
    if (json.useCooldownOnEnable != null) {
      result._hasUseCooldownOnEnable = true;
      result._useCooldownOnEnable = JsonToBoolean.fromJson(json.useCooldownOnEnable);
    }
    if (json.range != null) {
      result._hasRange = true;
      result._range = JsonToDouble.fromJson(json.range);
    }
    if (json.maxCharge != null) {
      result._hasMaxCharge = true;
      result._maxCharge = JsonToInt32.fromJson(json.maxCharge);
    }
    if (json.arc != null) {
      result._hasArc = true;
      result._arc = JsonToDouble.fromJson(json.arc);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasPrepTime) {
      result.prepTime = JsonToDouble.toJson(this._prepTime);
    }
    if (this._hasFinishTime) {
      result.finishTime = JsonToDouble.toJson(this._finishTime);
    }
    if (this._hasCooldown) {
      result.period = JsonToDouble.toJson(this._period);
    }
    if (this._hasUseInitialCooldown) {
      result.useInitialCooldown = JsonToBoolean.toJson(this._useInitialCooldown);
    }
    if (this._hasUseCooldownOnEnable) {
      result.useCooldownOnEnable = JsonToBoolean.toJson(this._useCooldownOnEnable);
    }
    if (this._hasRange) {
      result.range = JsonToDouble.toJson(this._range);
    }
    if (this._hasMaxCharge) {
      result.maxCharge = JsonToInt32.toJson(this._maxCharge);
    }
    if (this._hasArc) {
      result.arc = JsonToDouble.toJson(this._arc);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get prepTime() {
    return this._hasPrepTime ? this._prepTime : JsonToDouble.default;
  }
  get hasPrepTime() {
    return this._hasPrepTime;
  }
  setPrepTime(path, value) {
    return {type: 'SET', path: path.concat(['prepTime']), value};
  }
  deletePrepTime(path) {
    return {type: 'DELETE', path: path.concat(['prepTime'])};
  }
  /**
   * @returns {number}
   */
  get finishTime() {
    return this._hasFinishTime ? this._finishTime : JsonToDouble.default;
  }
  get hasFinishTime() {
    return this._hasFinishTime;
  }
  setFinishTime(path, value) {
    return {type: 'SET', path: path.concat(['finishTime']), value};
  }
  deleteFinishTime(path) {
    return {type: 'DELETE', path: path.concat(['finishTime'])};
  }
  /**
   * @returns {number}
   */
  get period() {
    return this._hasCooldown ? this._period : JsonToDouble.default;
  }
  get hasCooldown() {
    return this._hasCooldown;
  }
  setCooldown(path, value) {
    return {type: 'SET', path: path.concat(['period']), value};
  }
  deleteCooldown(path) {
    return {type: 'DELETE', path: path.concat(['period'])};
  }
  /**
   * @returns {boolean}
   */
  get useInitialCooldown() {
    return this._hasUseInitialCooldown ? this._useInitialCooldown : JsonToBoolean.default;
  }
  get hasUseInitialCooldown() {
    return this._hasUseInitialCooldown;
  }
  setUseInitialCooldown(path, value) {
    return {type: 'SET', path: path.concat(['useInitialCooldown']), value};
  }
  deleteUseInitialCooldown(path) {
    return {type: 'DELETE', path: path.concat(['useInitialCooldown'])};
  }
  /**
   * @returns {boolean}
   */
  get useCooldownOnEnable() {
    return this._hasUseCooldownOnEnable ? this._useCooldownOnEnable : JsonToBoolean.default;
  }
  get hasUseCooldownOnEnable() {
    return this._hasUseCooldownOnEnable;
  }
  setUseCooldownOnEnable(path, value) {
    return {type: 'SET', path: path.concat(['useCooldownOnEnable']), value};
  }
  deleteUseCooldownOnEnable(path) {
    return {type: 'DELETE', path: path.concat(['useCooldownOnEnable'])};
  }
  /**
   * @returns {number}
   */
  get range() {
    return this._hasRange ? this._range : JsonToDouble.default;
  }
  get hasRange() {
    return this._hasRange;
  }
  setRange(path, value) {
    return {type: 'SET', path: path.concat(['range']), value};
  }
  deleteRange(path) {
    return {type: 'DELETE', path: path.concat(['range'])};
  }
  /**
   * @returns {number}
   */
  get maxCharge() {
    return this._hasMaxCharge ? this._maxCharge : JsonToInt32.default;
  }
  get hasMaxCharge() {
    return this._hasMaxCharge;
  }
  setMaxCharge(path, value) {
    return {type: 'SET', path: path.concat(['maxCharge']), value};
  }
  deleteMaxCharge(path) {
    return {type: 'DELETE', path: path.concat(['maxCharge'])};
  }
  /**
   * @returns {number}
   */
  get arc() {
    return this._hasArc ? this._arc : JsonToDouble.default;
  }
  get hasArc() {
    return this._hasArc;
  }
  setArc(path, value) {
    return {type: 'SET', path: path.concat(['arc']), value};
  }
  deleteArc(path) {
    return {type: 'DELETE', path: path.concat(['arc'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "prepTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AbilityStats(this);
              copy._hasPrepTime = true;
              copy._prepTime = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasPrepTime) {
                return this;
              }
              const copy = new AbilityStats(this);
              copy._hasPrepTime = false;
              copy._prepTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "finishTime": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AbilityStats(this);
              copy._hasFinishTime = true;
              copy._finishTime = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasFinishTime) {
                return this;
              }
              const copy = new AbilityStats(this);
              copy._hasFinishTime = false;
              copy._finishTime = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "period": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AbilityStats(this);
              copy._hasCooldown = true;
              copy._period = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasCooldown) {
                return this;
              }
              const copy = new AbilityStats(this);
              copy._hasCooldown = false;
              copy._period = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useInitialCooldown": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AbilityStats(this);
              copy._hasUseInitialCooldown = true;
              copy._useInitialCooldown = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseInitialCooldown) {
                return this;
              }
              const copy = new AbilityStats(this);
              copy._hasUseInitialCooldown = false;
              copy._useInitialCooldown = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "useCooldownOnEnable": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AbilityStats(this);
              copy._hasUseCooldownOnEnable = true;
              copy._useCooldownOnEnable = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasUseCooldownOnEnable) {
                return this;
              }
              const copy = new AbilityStats(this);
              copy._hasUseCooldownOnEnable = false;
              copy._useCooldownOnEnable = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "range": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AbilityStats(this);
              copy._hasRange = true;
              copy._range = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasRange) {
                return this;
              }
              const copy = new AbilityStats(this);
              copy._hasRange = false;
              copy._range = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "maxCharge": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AbilityStats(this);
              copy._hasMaxCharge = true;
              copy._maxCharge = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMaxCharge) {
                return this;
              }
              const copy = new AbilityStats(this);
              copy._hasMaxCharge = false;
              copy._maxCharge = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "arc": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AbilityStats(this);
              copy._hasArc = true;
              copy._arc = JsonToDouble.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasArc) {
                return this;
              }
              const copy = new AbilityStats(this);
              copy._hasArc = false;
              copy._arc = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AbilityStats} other
   * @returns {AbilityStats}
   */
  merge(other) {
    const copy = new AbilityStats(this);
    if (other._hasPrepTime) {
      copy._hasPrepTime = true;
      copy._prepTime = other._prepTime;
    }
    if (other._hasFinishTime) {
      copy._hasFinishTime = true;
      copy._finishTime = other._finishTime;
    }
    if (other._hasCooldown) {
      copy._hasCooldown = true;
      copy._period = other._period;
    }
    if (other._hasUseInitialCooldown) {
      copy._hasUseInitialCooldown = true;
      copy._useInitialCooldown = other._useInitialCooldown;
    }
    if (other._hasUseCooldownOnEnable) {
      copy._hasUseCooldownOnEnable = true;
      copy._useCooldownOnEnable = other._useCooldownOnEnable;
    }
    if (other._hasRange) {
      copy._hasRange = true;
      copy._range = other._range;
    }
    if (other._hasMaxCharge) {
      copy._hasMaxCharge = true;
      copy._maxCharge = other._maxCharge;
    }
    if (other._hasArc) {
      copy._hasArc = true;
      copy._arc = other._arc;
    }
    return copy;
  }
}
AbilityStats.default = new AbilityStats();
class AbilityStats_Builder {
  constructor(value) {
    this._value = new AbilityStats(value);
  }
  build() {
    return new AbilityStats(this._value);
  }
  setPrepTime(value) {
    this._value._hasPrepTime = true;
    this._value._prepTime = value;
    return this;
  }
  deletePrepTime() {
    this._value._hasPrepTime = false;
    this._value._prepTime = null;
    return this;
  }
  setFinishTime(value) {
    this._value._hasFinishTime = true;
    this._value._finishTime = value;
    return this;
  }
  deleteFinishTime() {
    this._value._hasFinishTime = false;
    this._value._finishTime = null;
    return this;
  }
  setCooldown(value) {
    this._value._hasCooldown = true;
    this._value._period = value;
    return this;
  }
  deleteCooldown() {
    this._value._hasCooldown = false;
    this._value._period = null;
    return this;
  }
  setUseInitialCooldown(value) {
    this._value._hasUseInitialCooldown = true;
    this._value._useInitialCooldown = value;
    return this;
  }
  deleteUseInitialCooldown() {
    this._value._hasUseInitialCooldown = false;
    this._value._useInitialCooldown = null;
    return this;
  }
  setUseCooldownOnEnable(value) {
    this._value._hasUseCooldownOnEnable = true;
    this._value._useCooldownOnEnable = value;
    return this;
  }
  deleteUseCooldownOnEnable() {
    this._value._hasUseCooldownOnEnable = false;
    this._value._useCooldownOnEnable = null;
    return this;
  }
  setRange(value) {
    this._value._hasRange = true;
    this._value._range = value;
    return this;
  }
  deleteRange() {
    this._value._hasRange = false;
    this._value._range = null;
    return this;
  }
  setMaxCharge(value) {
    this._value._hasMaxCharge = true;
    this._value._maxCharge = value;
    return this;
  }
  deleteMaxCharge() {
    this._value._hasMaxCharge = false;
    this._value._maxCharge = null;
    return this;
  }
  setArc(value) {
    this._value._hasArc = true;
    this._value._arc = value;
    return this;
  }
  deleteArc() {
    this._value._hasArc = false;
    this._value._arc = null;
    return this;
  }
}
AbilityStats.Builder = AbilityStats_Builder;
class AbilityStats_WithParent {
  /**
   * @param {AbilityStats} value
   * @param {AbilityStats_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AbilityStats.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasPrepTime() {
    if (this._cachedHasPrepTime === undefined) {
      if (this._value.hasPrepTime) {
        this._cachedHasPrepTime = true;
      } else {
        this._cachedHasPrepTime = this._parent ? this._parent.hasPrepTime : false;
      }
    }
    return this._cachedHasPrepTime;
  }
  get prepTime() {
    if (this._cachedPrepTime === undefined) {
      if (this._value.hasPrepTime) {
        this._cachedPrepTime = this._value.prepTime;
      } else {
        this._cachedPrepTime = this._parent ? this._parent.prepTime : this._value.prepTime;
      }
    }
    return this._cachedPrepTime;
  }
  get hasFinishTime() {
    if (this._cachedHasFinishTime === undefined) {
      if (this._value.hasFinishTime) {
        this._cachedHasFinishTime = true;
      } else {
        this._cachedHasFinishTime = this._parent ? this._parent.hasFinishTime : false;
      }
    }
    return this._cachedHasFinishTime;
  }
  get finishTime() {
    if (this._cachedFinishTime === undefined) {
      if (this._value.hasFinishTime) {
        this._cachedFinishTime = this._value.finishTime;
      } else {
        this._cachedFinishTime = this._parent ? this._parent.finishTime : this._value.finishTime;
      }
    }
    return this._cachedFinishTime;
  }
  get hasCooldown() {
    if (this._cachedHasCooldown === undefined) {
      if (this._value.hasCooldown) {
        this._cachedHasCooldown = true;
      } else {
        this._cachedHasCooldown = this._parent ? this._parent.hasCooldown : false;
      }
    }
    return this._cachedHasCooldown;
  }
  get period() {
    if (this._cachedCooldown === undefined) {
      if (this._value.hasCooldown) {
        this._cachedCooldown = this._value.period;
      } else {
        this._cachedCooldown = this._parent ? this._parent.period : this._value.period;
      }
    }
    return this._cachedCooldown;
  }
  get hasUseInitialCooldown() {
    if (this._cachedHasUseInitialCooldown === undefined) {
      if (this._value.hasUseInitialCooldown) {
        this._cachedHasUseInitialCooldown = true;
      } else {
        this._cachedHasUseInitialCooldown = this._parent ? this._parent.hasUseInitialCooldown : false;
      }
    }
    return this._cachedHasUseInitialCooldown;
  }
  get useInitialCooldown() {
    if (this._cachedUseInitialCooldown === undefined) {
      if (this._value.hasUseInitialCooldown) {
        this._cachedUseInitialCooldown = this._value.useInitialCooldown;
      } else {
        this._cachedUseInitialCooldown = this._parent ? this._parent.useInitialCooldown : this._value.useInitialCooldown;
      }
    }
    return this._cachedUseInitialCooldown;
  }
  get hasUseCooldownOnEnable() {
    if (this._cachedHasUseCooldownOnEnable === undefined) {
      if (this._value.hasUseCooldownOnEnable) {
        this._cachedHasUseCooldownOnEnable = true;
      } else {
        this._cachedHasUseCooldownOnEnable = this._parent ? this._parent.hasUseCooldownOnEnable : false;
      }
    }
    return this._cachedHasUseCooldownOnEnable;
  }
  get useCooldownOnEnable() {
    if (this._cachedUseCooldownOnEnable === undefined) {
      if (this._value.hasUseCooldownOnEnable) {
        this._cachedUseCooldownOnEnable = this._value.useCooldownOnEnable;
      } else {
        this._cachedUseCooldownOnEnable = this._parent ? this._parent.useCooldownOnEnable : this._value.useCooldownOnEnable;
      }
    }
    return this._cachedUseCooldownOnEnable;
  }
  get hasRange() {
    if (this._cachedHasRange === undefined) {
      if (this._value.hasRange) {
        this._cachedHasRange = true;
      } else {
        this._cachedHasRange = this._parent ? this._parent.hasRange : false;
      }
    }
    return this._cachedHasRange;
  }
  get range() {
    if (this._cachedRange === undefined) {
      if (this._value.hasRange) {
        this._cachedRange = this._value.range;
      } else {
        this._cachedRange = this._parent ? this._parent.range : this._value.range;
      }
    }
    return this._cachedRange;
  }
  get hasMaxCharge() {
    if (this._cachedHasMaxCharge === undefined) {
      if (this._value.hasMaxCharge) {
        this._cachedHasMaxCharge = true;
      } else {
        this._cachedHasMaxCharge = this._parent ? this._parent.hasMaxCharge : false;
      }
    }
    return this._cachedHasMaxCharge;
  }
  get maxCharge() {
    if (this._cachedMaxCharge === undefined) {
      if (this._value.hasMaxCharge) {
        this._cachedMaxCharge = this._value.maxCharge;
      } else {
        this._cachedMaxCharge = this._parent ? this._parent.maxCharge : this._value.maxCharge;
      }
    }
    return this._cachedMaxCharge;
  }
  get hasArc() {
    if (this._cachedHasArc === undefined) {
      if (this._value.hasArc) {
        this._cachedHasArc = true;
      } else {
        this._cachedHasArc = this._parent ? this._parent.hasArc : false;
      }
    }
    return this._cachedHasArc;
  }
  get arc() {
    if (this._cachedArc === undefined) {
      if (this._value.hasArc) {
        this._cachedArc = this._value.arc;
      } else {
        this._cachedArc = this._parent ? this._parent.arc : this._value.arc;
      }
    }
    return this._cachedArc;
  }
  update(current, parent) {
    const result = new AbilityStats_WithParent(current, parent);
    return result;
  }
}
AbilityStats_WithParent.default = new AbilityStats_WithParent(AbilityStats.default, null);
AbilityStats.WithParent = AbilityStats_WithParent;
class AbilityStats_Descriptor {
  get prepTime() {
    if (!this._prepTime) {
      this._prepTime = {
        name: "prepTime",
        Name: "PrepTime",
        number: 1,
        protoType: 1,
        protoName: "prep_time",
        type: JsonToDouble,
        options: {
          comments: "The delay between the ability being cast and the effect being executed.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._prepTime;
  }
  get finishTime() {
    if (!this._finishTime) {
      this._finishTime = {
        name: "finishTime",
        Name: "FinishTime",
        number: 2,
        protoType: 1,
        protoName: "finish_time",
        type: JsonToDouble,
        options: {
          comments: "The delay between the effect being executed and the ability ending.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._finishTime;
  }
  get period() {
    if (!this._period) {
      this._period = {
        name: "period",
        Name: "Cooldown",
        number: 3,
        protoType: 1,
        protoName: "cooldown",
        type: JsonToDouble,
        options: {
          comments: "The cooldown of the ability or how long the unit must wait to use it again.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._period;
  }
  get useInitialCooldown() {
    if (!this._useInitialCooldown) {
      this._useInitialCooldown = {
        name: "useInitialCooldown",
        Name: "UseInitialCooldown",
        number: 7,
        protoType: 8,
        protoName: "use_initial_cooldown",
        type: JsonToBoolean,
        options: {
          comments: "If checked, this ability will start on cooldown.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useInitialCooldown;
  }
  get useCooldownOnEnable() {
    if (!this._useCooldownOnEnable) {
      this._useCooldownOnEnable = {
        name: "useCooldownOnEnable",
        Name: "UseCooldownOnEnable",
        number: 8,
        protoType: 8,
        protoName: "use_cooldown_on_enable",
        type: JsonToBoolean,
        options: {
          comments: "If checked, this ability will enter cooldown when it is disabled then enabled.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._useCooldownOnEnable;
  }
  get range() {
    if (!this._range) {
      this._range = {
        name: "range",
        Name: "Range",
        number: 4,
        protoType: 1,
        protoName: "range",
        type: JsonToDouble,
        options: {
          comments: "The maximum distance for the target of the ability.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._range;
  }
  get maxCharge() {
    if (!this._maxCharge) {
      this._maxCharge = {
        name: "maxCharge",
        Name: "MaxCharge",
        number: 5,
        protoType: 5,
        protoName: "max_charge",
        type: JsonToInt32,
        options: {
          comments: "The maximum number of charges for an ability. In order for an ability to be able to be cast, this number must be 1 or greater.",
          min: -1,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._maxCharge;
  }
  get arc() {
    if (!this._arc) {
      this._arc = {
        name: "arc",
        Name: "Arc",
        number: 6,
        protoType: 1,
        protoName: "arc",
        type: JsonToDouble,
        options: {
          comments: "The angle in front of the caster that targets must be in. If the target is outside this arc, the caster will attempt to turn to face the target before casting. Example: Arc 360 means the ability can be cast in any direction, 90 is a cone in front, and 0 is directly facing the target.",
          propertyRange: "0, 360",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._arc;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.prepTime,
        this.finishTime,
        this.period,
        this.useInitialCooldown,
        this.useCooldownOnEnable,
        this.range,
        this.maxCharge,
        this.arc,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForPrepTime",
        Name: "DummyOneofForPrepTime",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForFinishTime",
        Name: "DummyOneofForFinishTime",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForCooldown",
        Name: "DummyOneofForCooldown",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseInitialCooldown",
        Name: "DummyOneofForUseInitialCooldown",
        fields: [
          this.fields[3],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForUseCooldownOnEnable",
        Name: "DummyOneofForUseCooldownOnEnable",
        fields: [
          this.fields[4],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForRange",
        Name: "DummyOneofForRange",
        fields: [
          this.fields[5],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMaxCharge",
        Name: "DummyOneofForMaxCharge",
        fields: [
          this.fields[6],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForArc",
        Name: "DummyOneofForArc",
        fields: [
          this.fields[7],
        ],
      });
    }
    return this._oneofs;
  }
}
AbilityStats.descriptor = new AbilityStats_Descriptor();
export class AbilityCost {
  get descriptor() {
    return AbilityCost.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasHealth = false;
    this._health = null;
    this._hasMana = false;
    this._mana = null;
    this._hasGold = false;
    this._gold = null;
  }
  isEmpty() {
    if (this._hasHealth) return false;
    if (this._hasMana) return false;
    if (this._hasGold) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof AbilityCost) {
      return value;
    }
    return AbilityCost.fromJson(value);
  }
  static fromJson(json) {
    const result = new AbilityCost();
    if (json.health != null) {
      result._hasHealth = true;
      result._health = JsonToInt32.fromJson(json.health);
    }
    if (json.mana != null) {
      result._hasMana = true;
      result._mana = JsonToInt32.fromJson(json.mana);
    }
    if (json.gold != null) {
      result._hasGold = true;
      result._gold = JsonToInt32.fromJson(json.gold);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasHealth) {
      result.health = JsonToInt32.toJson(this._health);
    }
    if (this._hasMana) {
      result.mana = JsonToInt32.toJson(this._mana);
    }
    if (this._hasGold) {
      result.gold = JsonToInt32.toJson(this._gold);
    }
    return result;
  }
  /**
   * @returns {number}
   */
  get health() {
    return this._hasHealth ? this._health : JsonToInt32.default;
  }
  get hasHealth() {
    return this._hasHealth;
  }
  setHealth(path, value) {
    return {type: 'SET', path: path.concat(['health']), value};
  }
  deleteHealth(path) {
    return {type: 'DELETE', path: path.concat(['health'])};
  }
  /**
   * @returns {number}
   */
  get mana() {
    return this._hasMana ? this._mana : JsonToInt32.default;
  }
  get hasMana() {
    return this._hasMana;
  }
  setMana(path, value) {
    return {type: 'SET', path: path.concat(['mana']), value};
  }
  deleteMana(path) {
    return {type: 'DELETE', path: path.concat(['mana'])};
  }
  /**
   * @returns {number}
   */
  get gold() {
    return this._hasGold ? this._gold : JsonToInt32.default;
  }
  get hasGold() {
    return this._hasGold;
  }
  setGold(path, value) {
    return {type: 'SET', path: path.concat(['gold']), value};
  }
  deleteGold(path) {
    return {type: 'DELETE', path: path.concat(['gold'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "health": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AbilityCost(this);
              copy._hasHealth = true;
              copy._health = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasHealth) {
                return this;
              }
              const copy = new AbilityCost(this);
              copy._hasHealth = false;
              copy._health = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "mana": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AbilityCost(this);
              copy._hasMana = true;
              copy._mana = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasMana) {
                return this;
              }
              const copy = new AbilityCost(this);
              copy._hasMana = false;
              copy._mana = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "gold": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new AbilityCost(this);
              copy._hasGold = true;
              copy._gold = JsonToInt32.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasGold) {
                return this;
              }
              const copy = new AbilityCost(this);
              copy._hasGold = false;
              copy._gold = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {AbilityCost} other
   * @returns {AbilityCost}
   */
  merge(other) {
    const copy = new AbilityCost(this);
    if (other._hasHealth) {
      copy._hasHealth = true;
      copy._health = other._health;
    }
    if (other._hasMana) {
      copy._hasMana = true;
      copy._mana = other._mana;
    }
    if (other._hasGold) {
      copy._hasGold = true;
      copy._gold = other._gold;
    }
    return copy;
  }
}
AbilityCost.default = new AbilityCost();
class AbilityCost_Builder {
  constructor(value) {
    this._value = new AbilityCost(value);
  }
  build() {
    return new AbilityCost(this._value);
  }
  setHealth(value) {
    this._value._hasHealth = true;
    this._value._health = value;
    return this;
  }
  deleteHealth() {
    this._value._hasHealth = false;
    this._value._health = null;
    return this;
  }
  setMana(value) {
    this._value._hasMana = true;
    this._value._mana = value;
    return this;
  }
  deleteMana() {
    this._value._hasMana = false;
    this._value._mana = null;
    return this;
  }
  setGold(value) {
    this._value._hasGold = true;
    this._value._gold = value;
    return this;
  }
  deleteGold() {
    this._value._hasGold = false;
    this._value._gold = null;
    return this;
  }
}
AbilityCost.Builder = AbilityCost_Builder;
class AbilityCost_WithParent {
  /**
   * @param {AbilityCost} value
   * @param {AbilityCost_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return AbilityCost.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasHealth() {
    if (this._cachedHasHealth === undefined) {
      if (this._value.hasHealth) {
        this._cachedHasHealth = true;
      } else {
        this._cachedHasHealth = this._parent ? this._parent.hasHealth : false;
      }
    }
    return this._cachedHasHealth;
  }
  get health() {
    if (this._cachedHealth === undefined) {
      if (this._value.hasHealth) {
        this._cachedHealth = this._value.health;
      } else {
        this._cachedHealth = this._parent ? this._parent.health : this._value.health;
      }
    }
    return this._cachedHealth;
  }
  get hasMana() {
    if (this._cachedHasMana === undefined) {
      if (this._value.hasMana) {
        this._cachedHasMana = true;
      } else {
        this._cachedHasMana = this._parent ? this._parent.hasMana : false;
      }
    }
    return this._cachedHasMana;
  }
  get mana() {
    if (this._cachedMana === undefined) {
      if (this._value.hasMana) {
        this._cachedMana = this._value.mana;
      } else {
        this._cachedMana = this._parent ? this._parent.mana : this._value.mana;
      }
    }
    return this._cachedMana;
  }
  get hasGold() {
    if (this._cachedHasGold === undefined) {
      if (this._value.hasGold) {
        this._cachedHasGold = true;
      } else {
        this._cachedHasGold = this._parent ? this._parent.hasGold : false;
      }
    }
    return this._cachedHasGold;
  }
  get gold() {
    if (this._cachedGold === undefined) {
      if (this._value.hasGold) {
        this._cachedGold = this._value.gold;
      } else {
        this._cachedGold = this._parent ? this._parent.gold : this._value.gold;
      }
    }
    return this._cachedGold;
  }
  update(current, parent) {
    const result = new AbilityCost_WithParent(current, parent);
    return result;
  }
}
AbilityCost_WithParent.default = new AbilityCost_WithParent(AbilityCost.default, null);
AbilityCost.WithParent = AbilityCost_WithParent;
class AbilityCost_Descriptor {
  get health() {
    if (!this._health) {
      this._health = {
        name: "health",
        Name: "Health",
        number: 1,
        protoType: 5,
        protoName: "health",
        type: JsonToInt32,
        options: {
          comments: "How much health the unit loses when the ability is cast.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._health;
  }
  get mana() {
    if (!this._mana) {
      this._mana = {
        name: "mana",
        Name: "Mana",
        number: 2,
        protoType: 5,
        protoName: "mana",
        type: JsonToInt32,
        options: {
          comments: "How much mana the unit loses when the ability is cast.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._mana;
  }
  get gold() {
    if (!this._gold) {
      this._gold = {
        name: "gold",
        Name: "Gold",
        number: 3,
        protoType: 5,
        protoName: "gold",
        type: JsonToInt32,
        options: {
          comments: "How much gold the player loses when the ability is cast.",
          min: 0,
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._gold;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.health,
        this.mana,
        this.gold,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForHealth",
        Name: "DummyOneofForHealth",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForMana",
        Name: "DummyOneofForMana",
        fields: [
          this.fields[1],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForGold",
        Name: "DummyOneofForGold",
        fields: [
          this.fields[2],
        ],
      });
    }
    return this._oneofs;
  }
}
AbilityCost.descriptor = new AbilityCost_Descriptor();
